
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Tq4R", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $a2725444c60d8295$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-7ec2811c77";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $a2725444c60d8295$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    (0, $k2OeR.isPerformanceOnetrustEnabled)() && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedRequestCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    // @ts-ignore
    const experimentOverrides = (0, $EyEcw.getExperimentOverrides)(parsedRequestCookies);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideAtlassianAccountIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: experimentOverrides
    }).then(()=>{
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    pureClientMode: true,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    agileArticle: window.agileArticle,
                    agileOverview: window.agileOverview,
                    tutorial: window.tutorial,
                    customersLanding: window.customersLanding,
                    customerStory: window.customerStory,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    anchorContents: window.anchorContents,
                    persona: window.persona,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    children: Component
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                analyticsWebClient: analyticsWebClient,
                location: window.location,
                pricing: window.prices,
                availableProducts: window.availableProducts,
                agileArticle: window.agileArticle,
                agileOverview: window.agileOverview,
                tutorial: window.tutorial,
                customersLanding: window.customersLanding,
                customerStory: window.customerStory,
                templates: window.templates,
                partnerTemplates: window.partnerTemplates,
                collections: window.collections,
                categories: window.categories,
                userProfile: window.userProfile,
                userProfileStatus: window.userProfileStatus,
                userContext: window.userContext,
                userContextStatus: window.userContextStatus,
                loggedOutContext: window.loggedOutContext,
                loggedOutContextStatus: window.loggedOutContextStatus,
                countryCode: window.countryCode,
                anchorContents: window.anchorContents,
                composition: window._uniformPreloadedComposition,
                isUniformPlayground: window.isUniformPlayground,
                persona: window.persona,
                teamType: window.teamType,
                keyword: window.keyword,
                mlTemplateIds: window.mlTemplateIds,
                referrer: window.referrer,
                anchor: window.anchor,
                subAnchor: window.subAnchor,
                children: Component
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("EyEcw", function(module, exports) {

$parcel$export(module.exports, "getExperimentOverrides", function () { return $a71889fc68f9e7b9$export$8022ee0ca9bf74d6; });

var $5GZK9 = parcelRequire("5GZK9");
const $a71889fc68f9e7b9$export$8022ee0ca9bf74d6 = (parsedRequestCookies)=>{
    for (const cookieKey of Object.keys(parsedRequestCookies)){
        if (cookieKey === "atlassian_exp_overrides" && parsedRequestCookies["atlassian_exp_overrides"]) return $a71889fc68f9e7b9$export$d180d40f1827eef7(parsedRequestCookies["atlassian_exp_overrides"]);
    }
    return {}; // return empty overrides if none are found
};
const $a71889fc68f9e7b9$export$d180d40f1827eef7 = (cookie)=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5GZK9))).decompressFromBase64(cookie));
    } catch (e) {
        return {};
    }
};

});


parcelRegister("dRBBv", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePage", function () { return $2bf80102d69fc6c1$export$b7297290cb91015b; });

var $loA2J = parcelRequire("loA2J");

var $4LHd8 = parcelRequire("4LHd8");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $763wx = parcelRequire("763wx");

var $gkV6l = parcelRequire("gkV6l");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");
parcelRequire("53d2O");
var $g1XEw = parcelRequire("g1XEw");
const $2bf80102d69fc6c1$export$b7297290cb91015b = ()=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $4LHd8.default).checkGate("gwp-737-enable-intercom-chat-jsm");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $763wx.LicenseContextProvider), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
            analyticsPrefix: "jsm.show",
            productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
                appId: "p0ww63i2",
                triggerBoot: isBootIntercom,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
                    productKeys: [
                        (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK
                    ],
                    screenName: "wacJsmProductTourPage",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g1XEw.JiraServiceManagementSoftwarePageTemplate), {})
                })
            })
        })
    });
};

});
parcelRegister("763wx", function(module, exports) {

$parcel$export(module.exports, "LicenseContextProvider", function () { return $bdb9d0408c802688$export$cca99726a0e060c6; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $i8kxh = parcelRequire("i8kxh");

var $4himv = parcelRequire("4himv");
const $bdb9d0408c802688$export$b8df2a3e84891a11 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $bdb9d0408c802688$export$1828d2fb1045b6c5 = ()=>{
    const context = (0, $iSvIT.useContext)($bdb9d0408c802688$export$b8df2a3e84891a11);
    if (!context) throw new Error("useLicenseContext must be used within a LicenseContextProvider");
    return context;
};
const $bdb9d0408c802688$export$cca99726a0e060c6 = ({ children: children })=>{
    const [hasJsmLicense, setHasJsmLicense] = (0, $iSvIT.useState)(undefined);
    const [hasJpdLicense, setHasJpdLicense] = (0, $iSvIT.useState)(undefined);
    const { sites: sites } = (0, $4himv.useSitesContext)();
    (0, $iSvIT.useEffect)(()=>{
        if (sites !== undefined) {
            const hasJSM = sites.find((site)=>site.products.some((product)=>product === (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK));
            const hasJPD = sites.find((site)=>site.products.some((product)=>product === (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY));
            setHasJsmLicense(!!hasJSM);
            setHasJpdLicense(!!hasJPD);
        }
    }, [
        sites
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($bdb9d0408c802688$export$b8df2a3e84891a11.Provider, {
        value: {
            hasJsmLicense: hasJsmLicense,
            hasJpdLicense: hasJpdLicense
        },
        children: children
    });
};

});

parcelRegister("aRHrH", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("9O2F2")).IntercomProvider; });
parcelRequire("9O2F2");
parcelRequire("42XIn");

});
parcelRegister("9O2F2", function(module, exports) {

$parcel$export(module.exports, "IntercomProvider", function () { return $be094a112486886f$export$5091c5023e5c7eba; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $l4i0P = parcelRequire("l4i0P");

var $gkhN4 = parcelRequire("gkhN4");

var $7OS3I = parcelRequire("7OS3I");
const $be094a112486886f$var$isWindowExist = typeof window !== "undefined";
const $be094a112486886f$export$e578ca56db818a8e = /*#__PURE__*/ $iSvIT.createContext(undefined);
const $be094a112486886f$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $iSvIT.useRef(false);
    const isInit = $iSvIT.useRef(false);
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const initIntercomInstance = $iSvIT.useCallback(()=>{
        if (!isInit.current) {
            (0, $7OS3I.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    const boot = $iSvIT.useCallback(()=>{
        if ($be094a112486886f$var$isWindowExist && isInit.current && !isBooted.current) {
            const intercomSettings = window.intercomSettings ?? {
                app_id: appId
            };
            window.Intercom?.("boot", {
                alignment: "right",
                horizontal_padding: 20,
                vertical_padding: 20,
                custom_launcher_selector: "#intercomLauncher",
                ...intercomSettings
            });
            window.Intercom?.("trackEvent", "widget-loaded");
            isBooted.current = true;
        }
    }, [
        appId
    ]);
    const shutdown = $iSvIT.useCallback(()=>{
        if (!isBooted.current) return;
        if ($be094a112486886f$var$isWindowExist) {
            window.Intercom?.("shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $iSvIT.useCallback(()=>{
        if ($be094a112486886f$var$isWindowExist && isBooted.current) window.Intercom?.("show");
    }, []);
    const hide = $iSvIT.useCallback(()=>{
        if ($be094a112486886f$var$isWindowExist && isBooted.current) window.Intercom?.("hide");
    }, []);
    $iSvIT.useEffect(()=>{
        if ($be094a112486886f$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $l4i0P.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($be094a112486886f$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $iSvIT.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($be094a112486886f$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $be094a112486886f$export$28418e623d2470bc = ()=>{
    const context = $iSvIT.useContext($be094a112486886f$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("7OS3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f03bd135604494e$export$2e2bcd8739ae039; });
function $9f03bd135604494e$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $9f03bd135604494e$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($9f03bd135604494e$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $9f03bd135604494e$export$2e2bcd8739ae039 = $9f03bd135604494e$var$initializeIntercomInstance;

});


parcelRegister("42XIn", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("53d2O", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageTemplate", function () { return (parcelRequire("g1XEw")).JiraServiceManagementSoftwarePageTemplate; });

var $g1XEw = parcelRequire("g1XEw");

});
parcelRegister("g1XEw", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageTemplate", function () { return $7048bbea03a149cb$export$900b5a4539b43299; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $4LHd8 = parcelRequire("4LHd8");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("fovuc");
var $5ZfUA = parcelRequire("5ZfUA");

var $3FBn4 = parcelRequire("3FBn4");

var $47768 = parcelRequire("47768");

var $kex29 = parcelRequire("kex29");

var $jq0gD = parcelRequire("jq0gD");

var $9iWJ8 = parcelRequire("9iWJ8");

var $f6RqB = parcelRequire("f6RqB");

var $kMsPi = parcelRequire("kMsPi");

var $avg0H = parcelRequire("avg0H");

var $gd7EO = parcelRequire("gd7EO");

var $entQJ = parcelRequire("entQJ");

var $h3BeN = parcelRequire("h3BeN");

var $jcaSM = parcelRequire("jcaSM");

var $9g0oR = parcelRequire("9g0oR");

var $57Jg1 = parcelRequire("57Jg1");

var $daXMt = parcelRequire("daXMt");

var $4QWpU = parcelRequire("4QWpU");
const $7048bbea03a149cb$var$Gwp5090BannerExperimentIsActive = ()=>{
    const gwp5090BannerExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp5090ExperimentBannerJSM);
    return gwp5090BannerExperiment != undefined && gwp5090BannerExperiment.type === "enrolled" && gwp5090BannerExperiment.value === "butterbar";
};
const $7048bbea03a149cb$export$65c65bbd6805c2c3 = ()=>{
    const intl = (0, $f6qj2.default)();
    const gwp5090Team25Config = {
        identifier: "GWP5090.jsm-product-tour.butterbar",
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "team25-banners-and-butterbars.jsm.text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Be the first to demo our latest AI innovations and deliver game-changing experiences at Team \u201925!",
                values: (0, $3FBn4.DEFAULT_VALUES)
            })
        }),
        mobileText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "team25-banners-and-butterbars.jsm.mobile-text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Demo our latest AI tools at Team \u201925!",
                values: (0, $3FBn4.DEFAULT_VALUES)
            })
        }),
        productKey: "home",
        backgroundPreset: "gwp-5090-banners",
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4360jv8l7u81b0w6nn37fu86a2131624.webp",
            alt: "Team25",
            //Event name is not localized
            width: 200
        },
        linkText: intl.formatMessage({
            id: "team25-banners-and-butterbars.jsm.cta",
            defaultMessage: "Get your pass"
        }),
        linkUrl: "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=jsm_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=butterbar-banner_WEBTEAM-17396&event_id=216653",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "team25-banners-and-butterbars.jsm.cta",
                defaultMessage: "Get your pass"
            }),
            "data-label-english": "Get your pass"
        }
    };
    return $7048bbea03a149cb$var$Gwp5090BannerExperimentIsActive() ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $47768.EnhancedBannerAlert), {
        ...gwp5090Team25Config
    }) : null;
};
const $7048bbea03a149cb$export$54938012d431ec60 = ()=>{
    const intl = (0, $f6qj2.default)();
    const showWhitepaperBanner = (0, $4LHd8.default).checkGate("gwp-4691-forrester-banner");
    const showAiBanner = (0, $4LHd8.default).checkGate("wac-uip-butter-bar-jsm-gate");
    // GWP-4691: request for all content to be exclusively for English pages, 2025-01-09 - 2025-02-07
    const whitepaperBannerConfig = {
        identifier: "jira-service-management-software.banner.forrester-whitepaper",
        text: "New Study: The Total Economic Impact\u2122 of Jira Service Management.",
        linkText: "Learn more",
        linkUrl: (0, $3FBn4.useLocalizedHref)("/whitepapers/forrester-total-economic-impact-atlassian-for-itsm?utm_source=in-product-banner&utm_medium=banner&utm_campaign=P:jira-software*O:clm*F:cross-sell*C:gated-pdf*H:fy25q2*I:forrester-tei-2024*Y:itsm*"),
        dataEventProps: {
            "data-product-key": "jiraServiceManagement",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked"
        }
    };
    const aiBannerMessages = {
        identifier: "jira-service-management-software.atlassian-intelligence_exp",
        text: intl.formatMessage({
            id: "jira-service-management-software.banner-alert.atlassian-intelligence_exp",
            defaultMessage: "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "jira-service-management-software.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraServiceManagement",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };
    if ($7048bbea03a149cb$var$Gwp5090BannerExperimentIsActive()) return null;
    if (showWhitepaperBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), {
        ...whitepaperBannerConfig
    });
    if (showAiBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), {
        ...aiBannerMessages
    });
    return null;
};
const $7048bbea03a149cb$export$900b5a4539b43299 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jq0gD.default), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($7048bbea03a149cb$export$65c65bbd6805c2c3, {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-banner",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($7048bbea03a149cb$export$54938012d431ec60, {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-hero",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f6RqB.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-lifted-banner-team25",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $daXMt.Team25LiftedBanner), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-aiItsmSection",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kMsPi.AtlassianIntelligenceITSM), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-tabsSection",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $57Jg1.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-customersSection",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $entQJ.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-scalingSection",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jcaSM.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-tilesSection",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4QWpU.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-cardsSection",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $avg0H.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-integrationSection",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $h3BeN.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-ctaSection",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gd7EO.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-globalFooter",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
            })
        ]
    });
};

});
parcelRegister("fovuc", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

var $5ZfUA = parcelRequire("5ZfUA");

});
parcelRegister("5ZfUA", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return $a7a242474da496d8$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $a7a242474da496d8$var$containerStyles = null;
const $a7a242474da496d8$var$contentStyles = null;
const $a7a242474da496d8$var$closeIconStyles = null;
const $a7a242474da496d8$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $f6qj2.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    (0, $iSvIT.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $esG4f.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $esG4f.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $esG4f.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("47768", function(module, exports) {

$parcel$export(module.exports, "EnhancedBannerAlert", function () { return $6b681fb7f69a74b7$export$e2bb4f4abc9a31da; });
/* enhanced-banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $6b681fb7f69a74b7$export$e2bb4f4abc9a31da = (bannerInfo)=>{
    const bannerStorageItem = `BannerAlert_dismiss-${bannerInfo.identifier}`;
    const closeIconDataEventProps = {
        "data-product-key": bannerInfo.productKey,
        "data-event-component": "button",
        "data-event-container": "announcementBanner",
        "data-event": "clicked",
        "data-label": "Close",
        "data-label-english": "Close"
    };
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    const mobileClass = bannerInfo.mobileTextThirdScreen ? "three-screen" : "two-screen";
    (0, $iSvIT.useEffect)(()=>{
        const dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    let mobileProps = bannerInfo.imageProps;
    if (bannerInfo.imageMobileProps && bannerInfo.imageMobileProps.src) mobileProps = bannerInfo.imageMobileProps;
    const bannerBgPreset = bannerInfo.backgroundPreset ? `bg-${bannerInfo.backgroundPreset}` : `bg-none`;
    const bannerType = bannerInfo.bannerType ? `banner-type-${bannerInfo.bannerType}` : "banner-type-default";
    const bgLinkColor = bannerInfo.backgroundPreset == "gwp-5090-banners" ? "bgBlackBlue" : "bgWhite";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_bfhk1ybm _kqswh2mm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _85i5yh40 _189eh5ge _1dqonqa1 _5pio2icb _nzmgglyw _1auo1lef _21w0idpf _15641crf _s4s5idpf _1qlo1crf _7j8l1lk2 _jw2n1wug _1yvc1wug _19z9gktf _nue91vuk _1lrfidpf _pytjidpf _smywidpf _4tf1idpf _1dkqidpf _1i8zidpf _1twsidpf _c7u0idpf _1u1bjk2v _1876mq8p _gsz9mgnk _evayglyw _lhr7161t _1cmq12iu _88w1cd5j _5vmz1ejb _3kek1ejb _190eni2e _wb1217a9 _vb1gvgh6 _1at2oyge _49yzdf70 _1mafcd5j _waepcd5j _ojfccd5j _1yaacd5j _6rr71ybm _fsy11ybm _1gudcd5j _1m8acd5j _lkhdni7l _pu49ni7l _cfy01ule _18901k92 _1aavidpf _72q2idpf _11sc1y44 _i4q0idpf _n8ff1cby _qho21j28 _1w7d1hlo _102q1hbo _2utfmgnk _1vm51dlf _1e74altx _1o3a1izt _1blmu4dp _1si213i1 _1k051ms4 _1yip1f51 _6zpp1f51 _eyt5xchc _nxj7u58z _7w4fcd5j",
                `${bannerBgPreset} ${bannerType}`
            ]),
            "data-dismissed": isHidden ? "true" : undefined,
            "data-testid": "banner-alert-container",
            style: {
                ...bannerInfo.customCSS,
                "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
                "--_e0fbx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.purple500")),
                "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700")),
                "--_1avknp6": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.red")),
                "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow")),
                "--_b9m2cq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.green")),
                "--_1lpv4ka": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.lime")),
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1e0c1txw _2lx2vrvc _zulpzwfg _kqswh2mm _6rth12gs _sugaglyw",
                                    "desktop-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                            image: {
                                                width: 209,
                                                ...bannerInfo.imageProps
                                            },
                                            style: {
                                                maxWidth: "100%",
                                                height: "auto"
                                            },
                                            forceEagerLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_191w1xtt _4t3i1osq _sugaglyw",
                                            "line"
                                        ]),
                                        style: {
                                            "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700"))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1bsb1osq _1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpzwfg _na0i1bp4 _dh1a1y6m _2osn14y2 _ag851h6o _10ca1q9c"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                    "body-md"
                                                ]),
                                                children: bannerInfo.text
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                bgColor: bgLinkColor,
                                                text: bannerInfo.linkText,
                                                href: bannerInfo.linkUrl,
                                                type: "primary",
                                                dataEventProps: bannerInfo.dataEventProps
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1e0cglyw _2lx21bp4 _4cvr1h6o _suga1txw"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _p12f1osq _18zr7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                        image: {
                                                            width: 180,
                                                            ...mobileProps
                                                        },
                                                        style: {
                                                            maxWidth: "100%",
                                                            height: "auto"
                                                        },
                                                        forceEagerLoad: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileText
                                                })
                                            }),
                                            bannerInfo.mobileTextThirdScreen && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju251onc",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileTextThirdScreen
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        bgColor: bgLinkColor,
                                        text: bannerInfo.linkText,
                                        href: bannerInfo.linkUrl,
                                        type: "primary",
                                        dataEventProps: bannerInfo.dataEventProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                bannerInfo.bannerType != "lifted" && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    className: (0, $esG4f.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _rjxpidpf _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz",
                        `close-button-symbol`
                    ]),
                    "data-testid": "close-button",
                    "aria-label": "Close",
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    },
                    ...closeIconDataEventProps,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "24"
                    })
                })
            ]
        })
    });
};
const $6b681fb7f69a74b7$var$scrollUpTwoScreens = null;
const $6b681fb7f69a74b7$var$scrollUpThreeScreens = null;
const $6b681fb7f69a74b7$var$desktopContainerStyles = null;
const $6b681fb7f69a74b7$var$mobileContainerStyles = null;
const $6b681fb7f69a74b7$var$desktopLogoStyles = null;
const $6b681fb7f69a74b7$var$marqueeContainerStyles = null;
const $6b681fb7f69a74b7$var$marqueeItemStyle = null;
const $6b681fb7f69a74b7$var$marqueeItem1Styles = null;
const $6b681fb7f69a74b7$var$marqueeItem2Styles = null;
const $6b681fb7f69a74b7$var$marqueeItem3Styles = null;
const $6b681fb7f69a74b7$var$containerStyles = null;
const $6b681fb7f69a74b7$var$contentStyles = null;
const $6b681fb7f69a74b7$var$pStyle = null;
const $6b681fb7f69a74b7$var$lineStyle = null;
const $6b681fb7f69a74b7$var$closeStyles = null;

});

parcelRegister("jq0gD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a34c2ff8a2778c$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $gAJUc = parcelRequire("gAJUc");
const $c5a34c2ff8a2778c$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $esG4f.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $c5a34c2ff8a2778c$var$sticky = null;
var $c5a34c2ff8a2778c$export$2e2bcd8739ae039 = $c5a34c2ff8a2778c$var$StickyContainer;

});

parcelRegister("f6RqB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5bace569b97dee0$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $257fv = parcelRequire("257fv");
var $bZyGC = parcelRequire("bZyGC");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $dWbel = parcelRequire("dWbel");

var $8UlfF = parcelRequire("8UlfF");
const $a5bace569b97dee0$var$messages = (0, $6x1qA.defineMessages)({
    heading: {
        id: "wacJiraServiceManagementPage.hero-heading",
        defaultMessage: "Unlock high-velocity teams with AI-powered service management"
    },
    subheading: {
        id: "wacJiraServiceManagementPage.hero-subheading-gwp-4949",
        defaultMessage: "End bad service management for good. Unite Dev, IT, and business teams on a single AI-powered platform to deliver great service experiences."
    }
});
const $a5bace569b97dee0$var$JsmUseCaseProductTourOnWac = ()=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    // * Keep the original experiment event for attribution
    (0, $iSvIT.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            action: "exposed",
            actionSubject: "experiment",
            attributes: {
                cohort: "variation-one",
                experiment: "use-case-led-jsm-product-tour-on-wac"
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
        xcss: $a5bace569b97dee0$var$HeroContainerStyle,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        xcss: $a5bace569b97dee0$var$HeroHeadingWrapperStyles,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                            as: "h1",
                            xcss: $a5bace569b97dee0$var$HeroHeadingStyles,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                ...$a5bace569b97dee0$var$messages.heading,
                                values: {
                                    span: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                            as: "span",
                                            xcss: $a5bace569b97dee0$var$HeroHeadingSpanStyles,
                                            children: text
                                        })
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "p",
                        xcss: $a5bace569b97dee0$var$HeroSubheadingStyles,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...$a5bace569b97dee0$var$messages.subheading
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8UlfF.default), {})
        ]
    });
};
const $a5bace569b97dee0$var$HeroContainerStyle = (0, $j7TVc.xcss)({
    marginInline: "auto",
    width: "100%",
    overflow: "hidden",
    paddingBlockEnd: "space.400"
});
const $a5bace569b97dee0$var$HeroHeadingWrapperStyles = (0, $j7TVc.xcss)({
    position: "relative"
});
const $a5bace569b97dee0$var$HeroHeadingStyles = (0, $j7TVc.xcss)({
    textAlign: "center",
    fontSize: "48px",
    fontWeight: "800",
    lineHeight: "56px",
    maxWidth: "378px",
    marginBlockEnd: "space.0",
    [(0, $bZyGC.media).above.sm]: {
        maxWidth: "600px"
    },
    [(0, $bZyGC.media).above.lg]: {
        fontSize: "48px",
        maxWidth: "800px"
    }
});
const $a5bace569b97dee0$var$HeroHeadingSpanStyles = (0, $j7TVc.xcss)({
    fontWeight: "400"
});
const $a5bace569b97dee0$var$HeroSubheadingStyles = (0, $j7TVc.xcss)({
    textAlign: "center",
    marginBlockEnd: "space.400",
    maxWidth: "328px",
    fontSize: "20px",
    lineHeight: "28px",
    [(0, $bZyGC.media).above.xs]: {
        maxWidth: "420px"
    },
    [(0, $bZyGC.media).above.sm]: {
        maxWidth: "600px"
    },
    [(0, $bZyGC.media).above.lg]: {
        marginBlockEnd: "space.600",
        maxWidth: "800px",
        fontSize: "20px",
        lineHeight: "28px"
    }
});
var $a5bace569b97dee0$export$2e2bcd8739ae039 = $a5bace569b97dee0$var$JsmUseCaseProductTourOnWac;

});
parcelRegister("jXVyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8902b86efcd71d6$export$2e2bcd8739ae039; });

var $2eRSM = parcelRequire("2eRSM");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $j7TVc = parcelRequire("j7TVc");

var $1Lr0O = parcelRequire("1Lr0O");
var $e8902b86efcd71d6$var$flexGrowMap = {
    hug: (0, $j7TVc.xcss)({
        flexGrow: 0
    }),
    fill: (0, $j7TVc.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $e8902b86efcd71d6$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    return (0, $2ZUkg.jsx)((0, $1Lr0O.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: grow ? [
            $e8902b86efcd71d6$var$flexGrowMap[grow]
        ].concat((0, $2eRSM.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$e8902b86efcd71d6$var$Stack.displayName = "Stack";
var $e8902b86efcd71d6$export$2e2bcd8739ae039 = $e8902b86efcd71d6$var$Stack;

});
parcelRegister("1Lr0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $148f22484ac02ea1$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $ihHOk = parcelRequire("ihHOk");

var $j7TVc = parcelRequire("j7TVc");
var $148f22484ac02ea1$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $148f22484ac02ea1$var$flexDirectionMap = {
    column: (0, $2ZUkg.css)({
        flexDirection: "column"
    }),
    row: (0, $2ZUkg.css)({
        flexDirection: "row"
    })
};
var $148f22484ac02ea1$var$flexWrapMap = {
    wrap: (0, $2ZUkg.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $2ZUkg.css)({
        flexWrap: "nowrap"
    })
};
var $148f22484ac02ea1$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        alignItems: "stretch"
    })
};
var $148f22484ac02ea1$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $148f22484ac02ea1$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var xcssClassName = xcss && (0, $j7TVc.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)(Component, {
        role: role,
        css: [
            $148f22484ac02ea1$var$baseStyles,
            gap && (0, $ihHOk.spaceStylesMap).gap[gap],
            columnGap && (0, $ihHOk.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $ihHOk.spaceStylesMap).rowGap[rowGap],
            alignItems && $148f22484ac02ea1$var$alignItemsMap[alignItems],
            direction && $148f22484ac02ea1$var$flexDirectionMap[direction],
            justifyContent && $148f22484ac02ea1$var$justifyContentMap[justifyContent],
            wrap && $148f22484ac02ea1$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$148f22484ac02ea1$var$Flex.displayName = "Flex";
var $148f22484ac02ea1$export$2e2bcd8739ae039 = $148f22484ac02ea1$var$Flex;

});


parcelRegister("8UlfF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2d1e9f7e5f6b4db$export$2e2bcd8739ae039; });
/* hero-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $gf1F9 = parcelRequire("gf1F9");

var $8zMNO = parcelRequire("8zMNO");

var $257fv = parcelRequire("257fv");
var $hFDGT = parcelRequire("hFDGT");
var $6fxse = parcelRequire("6fxse");
var $bZyGC = parcelRequire("bZyGC");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");
parcelRequire("bQawl");
var $ca2XB = parcelRequire("ca2XB");

var $bhreu = parcelRequire("bhreu");

var $gXzhc = parcelRequire("gXzhc");

var $3FBn4 = parcelRequire("3FBn4");

var $kpWih = parcelRequire("kpWih");
// Styles for the content tab component
const $a2d1e9f7e5f6b4db$var$TabContentStyles = (0, $j7TVc.xcss)({
    minHeight: "fit-content",
    maxWidth: "1200px",
    marginInline: "auto",
    gridTemplateColumns: "1fr",
    [(0, $bZyGC.media).above.sm]: {
        gridTemplateColumns: "340px 1fr"
    },
    [(0, $bZyGC.media).above.md]: {
        gridTemplateColumns: "400px 1fr"
    }
});
const $a2d1e9f7e5f6b4db$var$TabContentLeft = (0, $j7TVc.xcss)({
    order: "2",
    paddingInline: "space.400",
    paddingBlock: "space.200",
    [(0, $bZyGC.media).above.sm]: {
        order: "1"
    },
    [(0, $bZyGC.media).above.lg]: {
        paddingInline: "space.0"
    }
});
const $a2d1e9f7e5f6b4db$var$TabContentRight = null;
const $a2d1e9f7e5f6b4db$var$TabContentLeftHeadingStyles = (0, $j7TVc.xcss)({
    fontWeight: "700",
    [(0, $bZyGC.media).above.md]: {
        fontSize: "32px",
        lineHeight: "38px"
    }
});
const $a2d1e9f7e5f6b4db$var$TabContentListStyles = (0, $j7TVc.xcss)({
    listStyle: "none",
    paddingInlineStart: "space.0",
    marginBlockStart: "space.0",
    marginBlockEnd: "space.400"
});
const $a2d1e9f7e5f6b4db$var$TabContentListItemTextStyles = (0, $j7TVc.xcss)({
    fontSize: "16px",
    lineHeight: "24px",
    paddingInlineEnd: "space.0",
    [(0, $bZyGC.media).above.md]: {
        fontSize: "20px",
        lineHeight: "28px"
    }
});
const $a2d1e9f7e5f6b4db$var$TabContentRightPictureStyles = null;
const $a2d1e9f7e5f6b4db$var$TabContentLeftCtaStyles = null;
const $a2d1e9f7e5f6b4db$var$TabContentRightCtaStylestest = null;
const $a2d1e9f7e5f6b4db$var$tryNowButtonMessage = {
    id: "jsm-use-case-hero-tabs.try-now",
    defaultMessage: "Try now"
};
const $a2d1e9f7e5f6b4db$var$joinADemoButtonMessage = {
    id: "jsm-use-case-hero-tabs.join-a-demo",
    defaultMessage: "Join a demo"
};
// Component for the content of each tab, has a heading, a picture and a list of items with icons
const $a2d1e9f7e5f6b4db$var$HeroTabContent = ({ heading: heading, picture: picture, list: list, imageAlt: imageAlt })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $hFDGT.default), {
        gap: "space.500",
        xcss: $a2d1e9f7e5f6b4db$var$TabContentStyles,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
                xcss: $a2d1e9f7e5f6b4db$var$TabContentLeft,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        paddingBlockEnd: "space.300",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            as: "h3",
                            level: "h700",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                as: "span",
                                xcss: $a2d1e9f7e5f6b4db$var$TabContentLeftHeadingStyles,
                                children: formatMessage(heading)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                        as: "ul",
                        space: "space.200",
                        xcss: $a2d1e9f7e5f6b4db$var$TabContentListStyles,
                        children: [
                            list.map((item)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $6fxse.default), {
                                    as: "li",
                                    alignBlock: "center",
                                    space: "space.100",
                                    children: [
                                        item.icon,
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                            as: "span",
                                            xcss: $a2d1e9f7e5f6b4db$var$TabContentListItemTextStyles,
                                            children: formatMessage(item.text)
                                        })
                                    ]
                                }, item.text.id)),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: "tab-content-ctas",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ca2XB.Button), {
                                        onClick: openCrossFlow,
                                        url: signupLink,
                                        text: formatMessage($a2d1e9f7e5f6b4db$var$tryNowButtonMessage),
                                        "aria-label": $a2d1e9f7e5f6b4db$var$tryNowButtonMessage,
                                        dataEventProps: {
                                            "data-product-key": "jiraServiceManagement",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "heroSection",
                                            "data-event": "clicked",
                                            "data-label": formatMessage($a2d1e9f7e5f6b4db$var$tryNowButtonMessage),
                                            "data-label-english": $a2d1e9f7e5f6b4db$var$tryNowButtonMessage.defaultMessage,
                                            "data-track-event": heading.defaultMessage
                                        },
                                        className: (0, $esG4f.default)([
                                            "_195g1wug _2rko1tcg _18zrgh54 _11q7b29m _1tkeckbl _1pfhpxbi _1wybgktf _19lc1b6v _1ywmidpf"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ca2XB.Button), {
                                        url: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/demo"),
                                        text: formatMessage($a2d1e9f7e5f6b4db$var$joinADemoButtonMessage),
                                        "aria-label": formatMessage($a2d1e9f7e5f6b4db$var$joinADemoButtonMessage),
                                        type: "secondary",
                                        className: (0, $esG4f.default)([
                                            "_195g1wug _2rko1tcg _18zrgh54 _bfhk1j28 _19it1j28 _1tkeckbl _1pfhpxbi _1wybgktf _syazvb1l _9oik1r31 _1bnx8stv _jf4cnqa1 _irr31j28 _jomr1j28 _1di61j28 _1ywmidpf",
                                            "button-join-demo"
                                        ]),
                                        dataEventProps: {
                                            "data-product-key": "jiraServiceManagement",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "heroSection",
                                            "data-event": "clicked",
                                            "data-label": formatMessage($a2d1e9f7e5f6b4db$var$joinADemoButtonMessage),
                                            "data-label-english": formatMessage($a2d1e9f7e5f6b4db$var$joinADemoButtonMessage)
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1f49kb7n _1h1tp5r3 _tzy4idpf _y44vqz3z _6o24cs5v _7dyz12kb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    ...picture,
                    image: {
                        src: picture.image.src,
                        alt: imageAlt ? formatMessage(imageAlt) : picture.image.alt
                    },
                    className: (0, $esG4f.default)([
                        "_1h1tbrkf _85i5pxbi _1jpx1dfr _18zxbrkf _1hgy1e8z"
                    ])
                })
            })
        ]
    });
};
const $a2d1e9f7e5f6b4db$var$iconDimensions = (0, $j7TVc.xcss)({
    width: "48px",
    height: "48px"
});
// Content for each tab
const $a2d1e9f7e5f6b4db$var$tabs = [
    {
        id: "it-support",
        textLabel: "IT support",
        dataLabelEnglish: "IT supporty",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ds5q16kwob38rb02h534e0dp37830mi7.webp",
                    alt: "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/0386o60lcs23u0wxo60c181728fvqa65.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_1_3)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M26.2857 13.7143L29.7212 13.7143V9.14286H18.279L18.279 13.7143L21.7143 13.7143V16.2073C15.8626 17.2822 11.4286 22.409 11.4286 28.5714V29.7143H36.5714V28.5714C36.5714 22.409 32.1374 17.2822 26.2857 16.2073V13.7143Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M38.8571 33.1429V37.7143L9.14286 37.7143V33.1429L38.8571 33.1429Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_1_3",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_2_3)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M32 20.5714L16 20.5714L16 16L32 16V20.5714Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M8 8V40H40V8H8ZM35.4286 12.5714H12.5714V24H17.1429C17.1429 27.7871 20.2129 30.8571 24 30.8571C27.7871 30.8571 30.8571 27.7871 30.8571 24H35.4286V12.5714Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_2_3",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: (0, $j7TVc.xcss)({
                            width: "48px",
                            height: "48px"
                        }),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M9.14286 28.5714L27.4286 3.42857V19.4286H38.8571L20.5714 44.5714V28.5714H9.14286Z",
                                fill: "#1868DB"
                            })
                        })
                    })
                }
            ]
        })
    },
    {
        id: "engineering-support",
        textLabel: "Engineering support",
        dataLabelEnglish: "Engineering support",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/h7r143ki88j2v6n656787rn8gc64yph1.webp",
                    alt: "A service project with options to see your queue, raise a request or see a knowledge base. One request is open. Its title is \u2018unhelpful error message\u2019 and has details about who raised the request and what it\u2019s about, as well as any linked requests."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/7v45j3bosu45w2lq477u15tjfem5783e.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_2_4)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M40 8H24L4.57143 27.4286L20.5714 43.4286L40 24V8ZM30.8571 14.8571C29.5948 14.8571 28.5714 15.8805 28.5714 17.1429C28.5714 18.4052 29.5948 19.4286 30.8571 19.4286C32.1195 19.4286 33.1429 18.4052 33.1429 17.1429C33.1429 15.8805 32.1195 14.8571 30.8571 14.8571Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_2_4",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_5_26225)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M19.4291 35.4279L40.0006 35.4275V7.99888L8.00056 7.99933V42.2846L19.4291 35.4279ZM33.1429 19.4286H14.8571V14.8571H33.1429V19.4286ZM25.1429 28.5714H14.8571V24H25.1429V28.5714Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_5_26225",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: (0, $j7TVc.xcss)({
                            width: "48px",
                            height: "48px"
                        }),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8zMNO.JiraIcon), {
                            size: "large",
                            appearance: "brand"
                        })
                    })
                }
            ]
        })
    },
    {
        id: "employee-support",
        textLabel: "Employee support",
        dataLabelEnglish: "Employee support",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/iejok30hpqe58a1ys00fwn86a4ho034m.webp",
                    alt: "A request portal with buttons for each company function to enter their part of the portal. For example, \u2018human resources - employee help\u2019 and \u2018Facilities - book an event\u2019."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/56m2ndu02rfu3qa17o7yl2i13t0628s0.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_5_26235)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M19.4291 35.4279L40.0006 35.4275V7.99888L8.00056 7.99933V42.2846L19.4291 35.4279ZM33.1429 19.4286H14.8571V14.8571H33.1429V19.4286ZM25.1429 28.5714H14.8571V24H25.1429V28.5714Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_5_26235",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_5_26238)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M33.1429 19.4286H24V14.8571H33.1429V19.4286Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M30.8571 27.4286H24V22.8571H30.8571V27.4286Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M17.1429 8V14.8571H8V33.7143C8 37.1858 10.8142 40 14.2857 40H33.1429C36.9299 40 40 36.9299 40 33.1429V8H17.1429ZM36.5714 11.4286H20.5714V33.7143C20.5714 34.7431 20.3243 35.7142 19.886 36.5714H33.1429C35.0364 36.5714 36.5714 35.0364 36.5714 33.1429V11.4286Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_5_26238",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_5_26241)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M26.9551 17.8125L37.2408 7.52679L40.4733 10.7593L30.1876 21.045L26.9551 17.8125Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M15.8037 12.5714L26.2856 23.0534V40.0002H21.7142V24.9469L12.5711 15.8039L12.5712 23.2157H7.99972V8.00002L23.2154 8.00001L23.2154 12.5714L15.8037 12.5714Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_5_26241",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }
            ]
        })
    },
    {
        id: "it-operations",
        textLabel: "IT operations",
        dataLabelEnglish: "IT operations",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/b5db764r7xdku57120or431jpot8843n.webp",
                    alt: "A request called \u2018Access service on staging\u2019 with requestor name (Andrew) and details about the request. There is also a risk summary and an option to either \u2018decline\u2019 or \u2018authorize\u2019 Andrew\u2019s request."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/27g7egubc3xn45a4r7e0t26d4q2p23r1.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_6_2)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M9.14286 28.5714L27.4286 3.42857V19.4286H38.8571L20.5714 44.5714V28.5714H9.14286Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_2",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_6_5)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M24 16L13.2273 26.7727C10.815 25.6499 9.14276 23.2043 9.14286 20.3681C9.14296 17.2863 11.142 14.5606 14.0814 13.6345L15.7552 13.1071L16.2039 11.8349C17.2558 8.8521 20.0747 6.85714 23.2376 6.85714C26.6222 6.85714 29.5824 9.13624 30.4479 12.4083L31.1837 15.1905H33.8809C37.2604 15.1905 40 17.9301 40 21.3095C40 24.2111 37.9804 26.641 35.2702 27.2702L24 16Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M32.4736 29.2407L29.2411 32.4732L26.2858 29.5179V40H21.7144V29.5181L18.7593 32.4732L15.5268 29.2407L24.0002 20.7673L32.4736 29.2407Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_5",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_6_8)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M16.9388 22.8571L21.7143 8H26.2857L31.0612 22.8571H16.9388Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M15.4694 27.4286L12.898 35.4286H9.14286V40H38.8571V35.4286H35.102L32.5306 27.4286H15.4694Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_8",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }
            ]
        })
    },
    {
        id: "customer-service",
        textLabel: "Customer service",
        dataLabelEnglish: "Customer service",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsCustomerServiceHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsCustomerServiceAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/qg16kaywc0437wuidqu2bjp63eot75ys.webp",
                    alt: "A company request portal with button for each function to raise their own requests. There is a panel open that has options to customize the look and feel of the portal, including its name and logo."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/0m8t568in48dx65h8dp781os3f8b53r7.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsCustomerServiceUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_6_11)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M23.3596 14.3508L9.4258 28.2845L7.36747 40.6292L19.7137 38.5724L33.6456 24.6405L23.3596 14.3508Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M36.0699 22.2161L39.1145 19.1716C40.8997 17.3863 40.8997 14.4919 39.1145 12.7066L35.2916 8.88372C33.5063 7.09847 30.6119 7.09847 28.8266 8.88372L25.784 11.9264L36.0699 22.2161Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_11",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsCustomerServiceUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_6_14)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M34.1099 39.2391C39.0378 35.9633 42.2857 30.3609 42.2857 24C42.2857 13.9011 34.0989 5.71429 24 5.71429C13.9011 5.71429 5.71429 13.9011 5.71429 24C5.71429 30.3609 8.96221 35.9633 13.8901 39.2391C14.783 34.468 18.9698 30.8571 24 30.8571C29.0302 30.8571 33.217 34.468 34.1099 39.2391ZM24 27.4286C27.7871 27.4286 30.8571 24.3585 30.8571 20.5714C30.8571 16.7843 27.7871 13.7143 24 13.7143C20.2129 13.7143 17.1429 16.7843 17.1429 20.5714C17.1429 24.3585 20.2129 27.4286 24 27.4286Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_14",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsCustomerServiceUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8zMNO.JiraIcon), {
                            size: "large",
                            appearance: "brand"
                        })
                    })
                }
            ]
        })
    }
];
const $a2d1e9f7e5f6b4db$var$useTabs = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useMemo(()=>$a2d1e9f7e5f6b4db$var$tabs, []);
};
// Here's the overrides that we need to make the component work with the new design.
const $a2d1e9f7e5f6b4db$var$HeroTabStyles = null;
const $a2d1e9f7e5f6b4db$var$HeroTabs = ()=>{
    const tabs = $a2d1e9f7e5f6b4db$var$useTabs();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1fpxglyw _6pje1txw _1vhk1wug _1ql51wug _2pzhglyw _1nb11q9c _cqnx1q9c _stua1y6m _1vowxy5q _1sdh1h6o _ar577vkz _1h311tcg _104bgktf _11uc1f4h _i63spxbi _12i1idpf _1sz71yqz _vtrs1yqz _6onnfg4m"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gXzhc.default), {
            tabContentType: "custom",
            id: "jsm-use-case-hero-tabs",
            dataProductKey: "jiraServiceManagement",
            label: "Product tour",
            tabs: tabs
        })
    });
};
var $a2d1e9f7e5f6b4db$export$2e2bcd8739ae039 = $a2d1e9f7e5f6b4db$var$HeroTabs;

});
parcelRegister("gf1F9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd2f563b70e4a361$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $glJen = parcelRequire("glJen");

var $2ZUkg = parcelRequire("2ZUkg");

var $lKLho = parcelRequire("lKLho");

var $f0Q8n = parcelRequire("f0Q8n");

var $XAEGR = parcelRequire("XAEGR");
var $bd2f563b70e4a361$var$_excluded = [
    "level",
    "size",
    "variant"
];
// https://atlassian.design/foundations/typography
var $bd2f563b70e4a361$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $bd2f563b70e4a361$var$headingResetStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $bd2f563b70e4a361$var$h900Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $bd2f563b70e4a361$var$h800Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $bd2f563b70e4a361$var$h700Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $bd2f563b70e4a361$var$h600Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $bd2f563b70e4a361$var$h500Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $bd2f563b70e4a361$var$h400Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$h300Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $bd2f563b70e4a361$var$h200Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$h100Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$inverseStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $bd2f563b70e4a361$var$subtlestStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $bd2f563b70e4a361$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $XAEGR;
    var _useHeading = (0, $lKLho.useHeading)($bd2f563b70e4a361$var$levelMap[level]), _useHeading2 = (0, $glJen.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $2ZUkg.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $bd2f563b70e4a361$var$headingResetStyles,
            level === "h100" && $bd2f563b70e4a361$var$h100Styles,
            level === "h200" && $bd2f563b70e4a361$var$h200Styles,
            level === "h300" && $bd2f563b70e4a361$var$h300Styles,
            level === "h400" && $bd2f563b70e4a361$var$h400Styles,
            level === "h500" && $bd2f563b70e4a361$var$h500Styles,
            level === "h600" && $bd2f563b70e4a361$var$h600Styles,
            level === "h700" && $bd2f563b70e4a361$var$h700Styles,
            level === "h800" && $bd2f563b70e4a361$var$h800Styles,
            level === "h900" && $bd2f563b70e4a361$var$h900Styles,
            color === "inverse" && $bd2f563b70e4a361$var$inverseStyles,
            color === "default" && isSubtleHeading && $bd2f563b70e4a361$var$subtlestStyles
        ]
    }, children);
};
var $bd2f563b70e4a361$export$2e2bcd8739ae039 = function(_ref2) {
    var level = _ref2.level, size = _ref2.size, variant = _ref2.variant, props = (0, $Zqzri.default)(_ref2, $bd2f563b70e4a361$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $2ZUkg.jsx)($bd2f563b70e4a361$var$Heading, (0, $y8mkn.default)({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $2ZUkg.jsx)((0, $f0Q8n.default), (0, $y8mkn.default)({
        variant: variant,
        size: size
    }, props));
};

});
parcelRegister("lKLho", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $fd6291971cdbcf3a$export$97a37b1befbbf9b1; });

var $iSvIT = parcelRequire("iSvIT");
// Allows support for heading levels 1-9 via aria-level
var $fd6291971cdbcf3a$var$HeadingLevelContext = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
var $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $iSvIT.useContext)($fd6291971cdbcf3a$var$HeadingLevelContext);
};
var $fd6291971cdbcf3a$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $fd6291971cdbcf3a$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($fd6291971cdbcf3a$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $fd6291971cdbcf3a$export$2e2bcd8739ae039 = $fd6291971cdbcf3a$var$HeadingLevelContextProvider;

});

parcelRegister("f0Q8n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aedf4bde1316c1cf$export$2e2bcd8739ae039; });

var $glJen = parcelRequire("glJen");

var $2ZUkg = parcelRequire("2ZUkg");

var $lKLho = parcelRequire("lKLho");

var $XAEGR = parcelRequire("XAEGR");
var $aedf4bde1316c1cf$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $aedf4bde1316c1cf$var$headingResetStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, #172B4D)",
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $aedf4bde1316c1cf$var$inverseStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $aedf4bde1316c1cf$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, variant = _ref.variant, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $XAEGR;
    // TODO: Temporary to move variant over to size
    var localSize = variant || size;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $lKLho.useHeading)($aedf4bde1316c1cf$var$sizeTagMap[localSize]), _useHeading2 = (0, $glJen.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    return (0, $2ZUkg.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $aedf4bde1316c1cf$var$headingResetStyles,
            localSize && $aedf4bde1316c1cf$var$headingSizeStylesMap[localSize],
            color === "inverse" && $aedf4bde1316c1cf$var$inverseStyles
        ]
    }, children);
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::057c0fe2015c2071afe3d694c5afcc0e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $aedf4bde1316c1cf$var$headingSizeStylesMap = {
    xxlarge: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $aedf4bde1316c1cf$export$2e2bcd8739ae039 = $aedf4bde1316c1cf$var$Heading;

});


parcelRegister("8zMNO", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $63e772beee40ff4e$export$c4b5b1f965d8b3eb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $63e772beee40ff4e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n    </svg>');
};
var $63e772beee40ff4e$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $63e772beee40ff4e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hFDGT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdd50dcba0f85b09$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $ihHOk = parcelRequire("ihHOk");

var $j7TVc = parcelRequire("j7TVc");
var $cdd50dcba0f85b09$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $cdd50dcba0f85b09$var$justifyItemsMap = {
    start: (0, $2ZUkg.css)({
        justifyItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyItems: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyItems: "stretch"
    })
};
var $cdd50dcba0f85b09$var$alignContentMap = {
    start: (0, $2ZUkg.css)({
        alignContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        alignContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        alignContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        alignContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        alignContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        alignContent: "stretch"
    })
};
var $cdd50dcba0f85b09$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    })
};
var $cdd50dcba0f85b09$var$baseStyles = (0, $2ZUkg.css)({
    display: "grid",
    boxSizing: "border-box"
});
var $cdd50dcba0f85b09$var$gridAutoFlowMap = {
    row: (0, $2ZUkg.css)({
        gridAutoFlow: "row"
    }),
    column: (0, $2ZUkg.css)({
        gridAutoFlow: "column"
    }),
    dense: (0, $2ZUkg.css)({
        gridAutoFlow: "dense"
    }),
    "row dense": (0, $2ZUkg.css)({
        gridAutoFlow: "row dense"
    }),
    "column dense": (0, $2ZUkg.css)({
        gridAutoFlow: "column dense"
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $cdd50dcba0f85b09$var$Grid = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || "div";
    var xcssClassName = xcss && (0, $j7TVc.parseXcss)(xcss);
    var style = gridTemplateAreas || gridTemplateColumns || gridTemplateRows ? Object.assign({}, {
        gridTemplateAreas: gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return '"'.concat(str, '"');
        }).join("\n") : undefined,
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows
    }) : undefined;
    return (0, $2ZUkg.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        css: [
            $cdd50dcba0f85b09$var$baseStyles,
            gap && (0, $ihHOk.spaceStylesMap).gap[gap],
            columnGap && (0, $ihHOk.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $ihHOk.spaceStylesMap).rowGap[rowGap],
            alignItems && $cdd50dcba0f85b09$var$alignItemsMap[alignItems],
            alignContent && $cdd50dcba0f85b09$var$alignContentMap[alignContent],
            justifyContent && $cdd50dcba0f85b09$var$justifyContentMap[justifyContent],
            autoFlow && $cdd50dcba0f85b09$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$cdd50dcba0f85b09$var$Grid.displayName = "Grid";
var $cdd50dcba0f85b09$export$2e2bcd8739ae039 = $cdd50dcba0f85b09$var$Grid;

});

parcelRegister("6fxse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48ce182491db562e$export$2e2bcd8739ae039; });

var $2eRSM = parcelRequire("2eRSM");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $j7TVc = parcelRequire("j7TVc");

var $1Lr0O = parcelRequire("1Lr0O");
var $48ce182491db562e$var$flexGrowMap = {
    hug: (0, $j7TVc.xcss)({
        flexGrow: 0
    }),
    fill: (0, $j7TVc.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $48ce182491db562e$var$separatorStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $48ce182491db562e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $48ce182491db562e$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $48ce182491db562e$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $2ZUkg.jsx)($48ce182491db562e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $2ZUkg.jsx)((0, $1Lr0O.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: grow ? [
            $48ce182491db562e$var$flexGrowMap[grow]
        ].concat((0, $2eRSM.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$48ce182491db562e$var$Inline.displayName = "Inline";
var $48ce182491db562e$export$2e2bcd8739ae039 = $48ce182491db562e$var$Inline;

});

parcelRegister("bQawl", function(module, exports) {
$parcel$export(module.exports, "Button", function () { return (parcelRequire("ca2XB")).Button; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("ca2XB")).Button; });

var $ca2XB = parcelRequire("ca2XB");

});
parcelRegister("ca2XB", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $62ad7d149d2e5a06$export$353f5b6fc5456de1; });
/* button.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $62ad7d149d2e5a06$var$buttonStyles = {
    primary: {
        // default styles
        darkblue: {
            textColor: "#ffffff",
            buttonBackgroundColor: "#0052cc",
            buttonHoverColor: "#0047B3",
            buttonFocusColor: "#004099",
            border: "none"
        },
        blueprimary700: {
            textColor: "#ffffff",
            buttonBackgroundColor: "#1868DB",
            buttonHoverColor: "#0047B3",
            buttonFocusColor: "#004099",
            border: "none"
        },
        yellow: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#ffab00",
            buttonHoverColor: "#ff991f",
            buttonFocusColor: "#ff8b00",
            border: "none"
        },
        green: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#79f2c0",
            buttonHoverColor: "#57d9a3",
            buttonFocusColor: "#36b37e",
            border: "none"
        },
        lightblue: {
            textColor: "#0052cc",
            buttonBackgroundColor: "#deebff",
            buttonHoverColor: "#B3D4FF",
            buttonFocusColor: "#4c9aff",
            border: "none"
        },
        gray: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "#DFE1E6",
            buttonFocusColor: "#c1c7d0",
            border: "none"
        },
        disabled: {
            textColor: "#97a0af",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        }
    },
    secondary: {
        darkblue: {
            textColor: "#0052cc",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#ebecf0",
            buttonFocusColor: "#deebff",
            border: `0.063rem solid #0052cc`
        },
        blueprimary700: {
            textColor: "#1868DB",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#ebecf0",
            buttonFocusColor: "#deebff",
            border: `0.063rem solid #1868DB`
        },
        yellow: {
            textColor: "#172b4d",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#f4f5f7",
            buttonFocusColor: "#FFF0B3",
            border: `0.063rem solid #ffab00`
        },
        green: {
            textColor: "#172b4d",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#f4f5f7",
            buttonFocusColor: "#e3fcef",
            border: `0.063rem solid #79f2c0`
        },
        white: {
            textColor: "#ffffff",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "rgba(255, 255, 255, 0.10)",
            buttonFocusColor: "rgba(255, 255, 255, 0.20)",
            border: `0.063rem solid #ffffff`
        },
        disabled: {
            textColor: "#97a0af",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        },
        whiteblue: {
            textColor: "#ffffff",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "rgba(255, 255, 255, 0.10)",
            buttonFocusColor: "rgba(255, 255, 255, 0.20)",
            border: `0.063rem solid #0052cc`
        }
    }
};
const $62ad7d149d2e5a06$var$getButtonSize = (size)=>{
    const buttonSize = size?.toLowerCase();
    if (buttonSize && buttonSize === "small") return "small";
    return "large";
};
const $62ad7d149d2e5a06$var$getButtonType = (type)=>{
    const buttonType = type?.toLowerCase();
    if (buttonType === "secondary") return "secondary";
    return "primary";
};
const $62ad7d149d2e5a06$var$isButtonColor = (color)=>{
    return color === "darkblue" || color === "blueprimary700" || color === "yellow" || color === "green" || color === "lightblue" || color === "white" || color === "gray" || color === "disabled";
};
const $62ad7d149d2e5a06$var$getButtonColor = (color, disabled)=>{
    if (disabled) return "disabled";
    const buttonColor = color?.toLowerCase();
    if (buttonColor && $62ad7d149d2e5a06$var$isButtonColor(buttonColor)) return buttonColor;
    return "darkblue";
};
const $62ad7d149d2e5a06$var$getButtonStyles = (type, color)=>{
    const styles = $62ad7d149d2e5a06$var$buttonStyles[type][color];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return styles ? styles : $62ad7d149d2e5a06$var$buttonStyles.primary.darkblue;
};
const $62ad7d149d2e5a06$export$353f5b6fc5456de1 = ({ text: text, type: type, color: color = "darkblue", size: size, onClick: onClick, url: url, externalLink: externalLink, inputType: inputType, disabled: disabled, className: className, dataEventProps: dataEventProps })=>{
    const buttonType = $62ad7d149d2e5a06$var$getButtonType(type);
    const buttonColor = $62ad7d149d2e5a06$var$getButtonColor(color, disabled);
    const { textColor: textColor, buttonBackgroundColor: buttonBackgroundColor, buttonHoverColor: buttonHoverColor, buttonFocusColor: buttonFocusColor, border: border } = $62ad7d149d2e5a06$var$getButtonStyles(buttonType, buttonColor);
    const buttonSize = $62ad7d149d2e5a06$var$getButtonSize(size);
    const fontSize = buttonSize === "large" ? "1rem" : "0.875rem";
    const height = buttonSize === "large" ? "2.5rem" : "2rem";
    const cursor = disabled ? "not-allowed" : "pointer";
    const styles = null;
    const handleOnClick = (e)=>{
        if (disabled) e.preventDefault();
        else onClick?.(e);
    };
    if ((onClick || inputType) && !url) return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        disabled: disabled,
        type: inputType,
        ...dataEventProps,
        style: {
            "--_1yb8o8o": (0, $43MIc.default)(buttonBackgroundColor),
            "--_pruigo": (0, $43MIc.default)(border),
            "--_srel9g": (0, $43MIc.default)(textColor),
            "--_1hkmuwx": (0, $43MIc.default)(buttonHoverColor),
            "--_15riry1": (0, $43MIc.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $43MIc.default)(fontSize),
            "--_roksyz": (0, $43MIc.default)(height),
            "--_15yp1he": (0, $43MIc.default)(cursor)
        },
        children: text
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        href: url,
        target: externalLink ? "_blank" : undefined,
        rel: externalLink ? "noreferrer" : undefined,
        ...dataEventProps,
        style: {
            "--_1yb8o8o": (0, $43MIc.default)(buttonBackgroundColor),
            "--_pruigo": (0, $43MIc.default)(border),
            "--_srel9g": (0, $43MIc.default)(textColor),
            "--_1hkmuwx": (0, $43MIc.default)(buttonHoverColor),
            "--_15riry1": (0, $43MIc.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $43MIc.default)(fontSize),
            "--_roksyz": (0, $43MIc.default)(height),
            "--_15yp1he": (0, $43MIc.default)(cursor)
        },
        children: text
    });
};

});


parcelRegister("kpWih", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $4733e7ac6f770226$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $4733e7ac6f770226$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    jsmUseCaseHeroTabsItSupportHeading: {
        id: "jsm-use-case-hero-tabs.it-support.heading",
        defaultMessage: "IT support"
    },
    jsmUseCaseHeroTabsItSupportAlt: {
        id: "jsm-use-case-hero-tabs.it-support.alt",
        defaultMessage: "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests."
    },
    jsmUseCaseHeroTabsItSupportUsp1: {
        id: "jsm-use-case-hero-tabs.it-support.usp1",
        defaultMessage: "Spin up a service desk with ease"
    },
    jsmUseCaseHeroTabsItSupportUsp2: {
        id: "jsm-use-case-hero-tabs.it-support.usp2",
        defaultMessage: "Manage all your requests in one place"
    },
    jsmUseCaseHeroTabsItSupportUsp3: {
        id: "jsm-use-case-hero-tabs.it-support.usp3",
        defaultMessage: "Automate support interactions with AI"
    },
    jsmUseCaseHeroTabsEngineeringSupportHeading: {
        id: "jsm-use-case-hero-tabs.engineering-support.heading",
        defaultMessage: "Engineering support"
    },
    jsmUseCaseHeroTabsEngineeringSupportAlt: {
        id: "jsm-use-case-hero-tabs.engineering-support.alt",
        defaultMessage: "A service project with options to see your queue, raise a request or see a knowledge base. One request is open. Its title is \u2018unhelpful error message\u2019 and has details about who raised the request and what it\u2019s about, as well as any linked requests. "
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp1: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp1",
        defaultMessage: "Triage your unplanned work"
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp2: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp2",
        defaultMessage: "Manage customer requests"
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp3: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp3",
        defaultMessage: "Link requests to Jira issues"
    },
    jsmUseCaseHeroTabsEmployeeSupportHeading: {
        id: "jsm-use-case-hero-tabs.employee-support.heading",
        defaultMessage: "Employee support"
    },
    jsmUseCaseHeroTabsEmployeeSupportAlt: {
        id: "jsm-use-case-hero-tabs.employee-support.alt",
        defaultMessage: "A request portal with buttons for each company function to enter their part of the portal. For example, \u2018human resources - employee help\u2019 and \u2018Facilities - book an event\u2019."
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp1: {
        id: "jsm-use-case-hero-tabs.employee-support.usp1",
        defaultMessage: "Ensure anyone can get help quickly"
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp2: {
        id: "jsm-use-case-hero-tabs.employee-support.usp2",
        defaultMessage: "Empower employees with self-service"
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp3: {
        id: "jsm-use-case-hero-tabs.employee-support.usp3",
        defaultMessage: "Deflect requests and save time with an AI-powered Virtual Service Agent"
    },
    jsmUseCaseHeroTabsItOperationHeading: {
        id: "jsm-use-case-hero-tabs.it-operation.heading",
        defaultMessage: "IT operations"
    },
    jsmUseCaseHeroTabsItOperationAlt: {
        id: "jsm-use-case-hero-tabs.it-operation.alt",
        defaultMessage: "A request called \u2018Access service on staging\u2019 with requestor name (Andrew) and details about the request. There is also a risk summary and an option to either \u2018decline\u2019 or \u2018authorize\u2019 Andrew\u2019s request."
    },
    jsmUseCaseHeroTabsItOperationUsp1: {
        id: "jsm-use-case-hero-tabs.it-operations.usp1",
        defaultMessage: "Automate change requests"
    },
    jsmUseCaseHeroTabsItOperationUsp2: {
        id: "jsm-use-case-hero-tabs.it-operations.usp2",
        defaultMessage: "Deploy with confidence"
    },
    jsmUseCaseHeroTabsItOperationUsp3: {
        id: "jsm-use-case-hero-tabs.it-operations.usp3",
        defaultMessage: "Detect, resolve, and prevent incidents with AI"
    },
    jsmUseCaseHeroTabsCustomerServiceHeading: {
        id: "jsm-use-case-hero-tabs.customer-service.heading",
        defaultMessage: "Customer service"
    },
    jsmUseCaseHeroTabsCustomerServiceAlt: {
        id: "jsm-use-case-hero-tabs.customer-service.alt",
        defaultMessage: "A company request portal with button for each function to raise their own requests. There is a panel open that has options to customize the look and feel of the portal, including its name and logo."
    },
    jsmUseCaseHeroTabsCustomerServiceUsp1: {
        id: "jsm-use-case-hero-tabs.customer-servicet.usp1",
        defaultMessage: "Customize your help center"
    },
    jsmUseCaseHeroTabsCustomerServiceUsp2: {
        id: "jsm-use-case-hero-tabs.customer-service.usp1",
        defaultMessage: "Automate repetitive tasks"
    },
    jsmUseCaseHeroTabsCustomerServiceUsp3: {
        id: "jsm-use-case-hero-tabs.customer-service.usp3",
        defaultMessage: "Link requests to Jira issues"
    }
});

});



parcelRegister("kMsPi", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligenceITSM", function () { return $0a7427d500304e0f$export$670499c84e6e6f84; });
/* ai-itsm.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $cssyA = parcelRequire("cssyA");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $6qcUm = parcelRequire("6qcUm");

var $Tf71T = parcelRequire("Tf71T");
const $0a7427d500304e0f$export$670499c84e6e6f84 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $f6qj2.default)();
    const title = formatMessage({
        id: "jsm-product-tour.ai-section.title-text",
        defaultMessage: "Smarter ITSM, powered by AI"
    });
    const subTitle = formatMessage({
        id: "jsm-product-tour.ai-section.subtitle-text",
        defaultMessage: "AI helps support and operations teams stay ahead by predicting issues, suggesting actions, and automating resolutions to turn insights into action."
    });
    const buttonText = formatMessage({
        id: "jsm-product-tour.ai-section.button-text",
        defaultMessage: "Explore AI in ITSM"
    });
    const videoLink = (0, $Tf71T.getAiVideoJSM)(locale);
    const imageLink = (0, $Tf71T.getAiImageJSM)(locale);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "gwp-4949-button-clicked",
                section: "ai-section"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _6a6z1h6o _bfhk17la _syazcd5j _ca0qvbgk _u5f39by0 _n3tdvbgk _19bv9by0 _zulpzwfg"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6qcUm.Intelligence), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_1wybckbl _k48p1fw0 _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_syazcd5j _y3gn1h6o _ect4bzd7 _1wyb7vkz _k48p1nn1 _p12f1ogm _1bsb1osq"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1tz91y44 _1k797vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "secondary",
                            color: "white",
                            colorAgainst: "other",
                            size: "large",
                            href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/features/itsm/ai"),
                            onClick: handleClick,
                            dataEventProps: {
                                "data-product-key": "jira",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-label": "explore-atlassian-intelligence",
                                "data-label-english": "Explore AI in ITSM",
                                "data-track-event": "jira-pt.ai-section.explore-atlassian-intelligence"
                            },
                            children: buttonText
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                        playsInline: true,
                        muted: true,
                        preload: "auto",
                        autoPlay: true,
                        loop: true,
                        className: (0, $esG4f.default)([
                            "_p12f1uof _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _19451ogm _liwcglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoLink,
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                        image: {
                            src: imageLink,
                            alt: "",
                            width: 2752,
                            height: 1838
                        },
                        className: (0, $esG4f.default)([
                            "_mezj1osq _bna71wug _14bq7vkz _3tce7vkz _1ym67vkz _1xr17vkz _1z4kglyw"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1tkemgvx _12vemgnk _ouxlbbky _1lrwykpt _bfhku7gi _1itkoro1 _1jgo1wqb _1w8u1dh4"
                ])
            })
        ]
    });
};
const $0a7427d500304e0f$var$aiSectionStyles = null;
const $0a7427d500304e0f$var$imageStyles = null;
const $0a7427d500304e0f$var$videoStyles = null;
const $0a7427d500304e0f$var$titleStyles = null;
const $0a7427d500304e0f$var$subTitleStyles = null;
const $0a7427d500304e0f$var$buttonStyles = null;
const $0a7427d500304e0f$var$footerStyles = null;

});

parcelRegister("avg0H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c85ff98bbf90c6d$export$2e2bcd8739ae039; });
/* cards.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("9HFEq");
var $dbhgV = parcelRequire("dbhgV");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $3c85ff98bbf90c6d$var$pageSection = null;
const $3c85ff98bbf90c6d$var$divider = null;
const $3c85ff98bbf90c6d$var$resourcesHeader = null;
const $3c85ff98bbf90c6d$var$cardsContainer = null;
const $3c85ff98bbf90c6d$var$Card = ({ pictureProps: pictureProps, headerText: headerText, eyebrowText: eyebrowText, orientation: orientation, primaryLink: primaryLink })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), {
        headerText: headerText,
        eyebrowText: eyebrowText,
        pictureProps: pictureProps,
        orientation: orientation,
        ctaProps: {
            primaryLinkProps: {
                type: "primary",
                text: primaryLink.text,
                href: primaryLink.link,
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": `cardSection`,
                    "data-product-key": "jiraServiceDesk",
                    "data-label": primaryLink.text,
                    "data-label-english": primaryLink.dataLabelEnglish
                }
            }
        }
    });
const $3c85ff98bbf90c6d$var$CardsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardData = [
        {
            pictureProps: {
                image: {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:01c0f236-3cb0-4068-8ca8-30219b394ae3/jsm-tei-report.png?cdnVersion=1290",
                    alt: intl.formatMessage({
                        id: "jira-service-management.resources.card0.image.alt",
                        defaultMessage: `Cover of spiral notebook titled: "The Total Economic Impact TM of Atlassian Jira Service Management"`
                    }),
                    width: 1136,
                    height: 680
                }
            },
            headerText: intl.formatMessage({
                id: "jira-service-management.resources.card0.body",
                defaultMessage: "The Total Economic Impact\u2122 of Atlassian for ITSM"
            }),
            eyebrowText: intl.formatMessage({
                id: "jira-service-management.resources.card0.header",
                defaultMessage: "forrester report"
            }),
            primaryLink: {
                text: intl.formatMessage({
                    id: "jira-service-management.resources.card0.primary.link",
                    defaultMessage: "Get report"
                }),
                dataLabelEnglish: "Get report",
                link: (0, $3FBn4.useLocalizedHref)("/jira/service-management/total-economic-impact-hub")
            },
            orientation: "vertical"
        },
        {
            pictureProps: {
                sources: [
                    {
                        srcSet: "https://wac-cdn.atlassian.com/dam/jcr:6d1ac7d5-56e6-4ca0-933a-cf4c28c646e5/jsm-get-started-wide.png?cdnVersion=1290",
                        media: "(max-width: 63.99rem)"
                    }
                ],
                image: {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:cc80a855-d6a0-4083-8f34-b46a3122bcc1/jsm-get-started.png?cdnVersion=1290",
                    alt: intl.formatMessage({
                        id: "jira-service-management.resources.card1.image.alt",
                        defaultMessage: "Customers being helped out at a service desk by an attendant"
                    })
                }
            },
            headerText: intl.formatMessage({
                id: "jira-service-management.resources.card1.body",
                defaultMessage: "Get started with Jira Service Management"
            }),
            eyebrowText: intl.formatMessage({
                id: "jira-service-management.resources.card1.header",
                defaultMessage: "Guides"
            }),
            primaryLink: {
                text: intl.formatMessage({
                    id: "jira-service-management.resources.card1.primary.link",
                    defaultMessage: "Learn more"
                }),
                dataLabelEnglish: "Learn more",
                link: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/product-guide/getting-started/quick-start-guide")
            },
            orientation: "horizontal"
        },
        {
            pictureProps: {
                sources: [
                    {
                        srcSet: "https://wac-cdn.atlassian.com/dam/jcr:e40a81ed-cc02-472d-a62b-f5b2d21d11ef/tips-and-tricks-wide.png?cdnVersion=1290",
                        media: "(max-width: 63.99rem)"
                    }
                ],
                image: {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:e5c74440-938a-4c00-bd28-1bd53a67d798/jsm-tips.png?cdnVersion=1290",
                    alt: intl.formatMessage({
                        id: "jira-service-management.resources.card2.image.alt",
                        defaultMessage: "Two people learning concepts drawn on a black board"
                    })
                }
            },
            headerText: intl.formatMessage({
                id: "jira-service-management.resources.card2.body",
                defaultMessage: "Tips, tricks, and best practices for managing IT service delivery"
            }),
            eyebrowText: intl.formatMessage({
                id: "jira-service-management.resources.card2.header",
                defaultMessage: "ITSM"
            }),
            primaryLink: {
                text: intl.formatMessage({
                    id: "jira-service-management.resources.card2.primary.link",
                    defaultMessage: "Learn more"
                }),
                dataLabelEnglish: "Learn more",
                link: (0, $3FBn4.useLocalizedHref)("/itsm")
            },
            orientation: "horizontal"
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_12l21wug _ahbq1wug _1ul91osq _1yt4wf4d _11rm1hrf _kqswh2mm _1aahidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                        className: (0, $esG4f.default)([
                            "_4t3iyh40 _1h6dj1oc _bfhkj1oc _1bsb1osq _19itidpf _dbjgvbgk _1hvk1wug _isu4zwfg _15qm1wug _3wvkzwfg _1fbnidpf _1uby7vkz _1t0ridpf"
                        ])
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _cg411bqd _l5k1bfng _1n467vkz _if5yidpf _1gnp7vkz _7e5bidpf _qc0pahaf _1kll1k8s"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "jira-service-management.resources.header",
                            defaultMessage: "Jira Service Management resources",
                            tagName: "h2"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _p12f1fra _zulpxy5q _19pkckbl _otyr7vkz _1rqtf9jr _12fk19ia _1da7z7l7 _4u9p13qz _fjgkz7l7 _1yx710xu _13i17vkz _d08ozwfg _1u3w7vkz _fxxg7vkz _9bmlxy5q _1qofzwfg _19fgzwfg _mw66zwfg _nqa3zwfg _1ic8gktf _13d6idpf _1aqaidpf _1yqbidpf _1ihtidpf _31yooqnp _uq2s1nn1 _lgg41tcg _tz0rt94y _qldh19bv _1oazidpf _qly9idpf _3nktidpf _1ritidpf _160g1nn1 _1vopidpf _1ugpidpf _1n35idpf _1j70idpf"
                        ]),
                        children: cardData.map((card, index)=>{
                            const cardStyles = [
                                index === 0 && null,
                                index === 1 && null,
                                index === 2 && null
                            ];
                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    index === 0 && "_nd5l1820 _1och1txw _15jj1bp4 _71rf1j6v _1ifi1ns9 _lin31wug",
                                    index === 1 && "_nd5l1hob _7vrlmxmv _ehw4idpf _12ii1txw _25qu1bp4",
                                    index === 2 && "_nd5l5lkg _7vrlmxmv _ehw4idpf _12ii1txw _25qu1bp4"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($3c85ff98bbf90c6d$var$Card, {
                                    ...card
                                })
                            }, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                        className: (0, $esG4f.default)([
                            "_4t3iyh40 _1h6dj1oc _bfhkj1oc _1bsb1osq _19itidpf _dbjgvbgk _1hvk1wug _isu4zwfg _15qm1wug _3wvkzwfg _1fbnidpf _1uby7vkz _1t0ridpf"
                        ])
                    })
                })
            ]
        })
    });
};
var $3c85ff98bbf90c6d$export$2e2bcd8739ae039 = $3c85ff98bbf90c6d$var$CardsSection;

});
parcelRegister("9HFEq", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("dbhgV")).Card; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("dbhgV")).Card; });

var $dbhgV = parcelRequire("dbhgV");

});
parcelRegister("dbhgV", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $1d73d5771cc6d344$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $ix9oc = parcelRequire("ix9oc");
const $1d73d5771cc6d344$var$containerStyles = null;
const $1d73d5771cc6d344$var$contentBlockStyles = null;
const $1d73d5771cc6d344$var$barStyles = null;
const $1d73d5771cc6d344$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor ?? "#ffffff";
    const cardBackTextColor = textColor ?? "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor ?? "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $43MIc.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $43MIc.default)(cardBackTextColor),
            "--_8vvi5m": (0, $43MIc.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $esG4f.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});



parcelRegister("gd7EO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05d3458b1c028341$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $ix9oc = parcelRequire("ix9oc");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $05d3458b1c028341$var$ctaSectionStyles = null;
const $05d3458b1c028341$var$CTASection = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const ctaButtonText = intl.formatMessage({
        id: "jira-service-management.cta.button",
        defaultMessage: "Try it free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1h3e1khj _12vemgnk _1lrw1dfr _ouxl1ssb _w0ge1pfc _syazu67f _ixrs16xz _4x03idpf _94fo16xz _z9bjidpf _19xdvbgk _1k6widpf _17z4vbgk _1ymhidpf _1bao7vkz _1xsmidpf _eabl7vkz _z140idpf _1upwahaf _gamf11ph _16hmidpf _11vc1nn1 _16o61k8s _12kzdlk8 _im8vidpf _z1pmidpf _15kdidpf _qkjtidpf _j9pmidpf _7vjp1nn1 _1l677vkz _q19bb4wl"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.default), {
                headerText: intl.formatMessage({
                    id: "jira-service-management.cta.header",
                    defaultMessage: "Get started with Jira Service Management today"
                }),
                headerType: "h2",
                isCentered: true,
                ctaProps: {
                    buttonProps: {
                        text: ctaButtonText,
                        color: "yellow",
                        className: "jsm-hero-section-cta",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraServiceManagement",
                            "data-label-english": "Try it free",
                            "data-label": ctaButtonText
                        },
                        onClick: openCrossFlow,
                        url: signupLink
                    },
                    secondaryLinkProps: {
                        text: intl.formatMessage({
                            id: "jira-service-management.cta.link",
                            defaultMessage: "Explore plans"
                        }),
                        href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/pricing"),
                        type: "primary",
                        bgColor: "bgBlackBlue",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraServiceManagement"
                        }
                    }
                }
            })
        })
    });
};
var $05d3458b1c028341$export$2e2bcd8739ae039 = $05d3458b1c028341$var$CTASection;

});

parcelRegister("entQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $629e22e9cb1e779a$export$2e2bcd8739ae039; });
/* customers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $ix9oc = parcelRequire("ix9oc");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("2pEWv");
var $fXpYT = parcelRequire("fXpYT");
const $629e22e9cb1e779a$var$sectionStyle = null;
const $629e22e9cb1e779a$var$customerQuoteStyle = null;
const $629e22e9cb1e779a$var$image = null;
const $629e22e9cb1e779a$var$blurbStyle = null;
const $629e22e9cb1e779a$var$nameStyle = null;
const $629e22e9cb1e779a$var$benefitStyle = null;
const $629e22e9cb1e779a$var$inlineLogosProp = [
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hil7171bgf726i008u426ly20lmckpd.svg",
        alt: "Square logo",
        width: "144px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1728do7q372772c56nn1d6176lgv7g41.svg",
        alt: "Sotheby's logo",
        width: "146px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ol564g48h6368my8s6v44fcc1w7jtds1.svg",
        alt: "Domino's logo",
        width: "162px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/58qk6136v662bx6i084qm16f383471s2.svg",
        alt: "Puppet logo",
        width: "99px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8h645v2kexjar2qvcn757ao4cws2jj8u.svg",
        alt: "Twitter logo",
        width: "43px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5vhj2x4xck7s3f4gjhtin3ges02a2mn0.svg",
        alt: "The Telegraph logo",
        width: "219px"
    }
];
const $629e22e9cb1e779a$var$patternLogosJSMCustomersSectionStyle = null;
const $629e22e9cb1e779a$var$Benefit = ({ title: title, description: description })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp1k8s _18s8zu5n _ggmh13ei _r8ntbfng _1wcwze3t _q7gq1j6v _1adi1nn1 _xw2dze3t"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: description
            })
        ]
    });
const $629e22e9cb1e779a$var$CustomerQuote = ({ quote: quote, name: name, imageLink: imageLink, imageAltText: imageAltText, benefits: benefits })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1pfhpxbi"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.default), {
                src: imageLink,
                alt: imageAltText,
                className: (0, $esG4f.default)([
                    "_1bsbfp70"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyb1k8s _k48powjs _vwz4nqt0 _18s8zu5n _1cqs1k92 _srwzpxbi _18ghnl7k"
                ]),
                children: quote
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyboqnp _k48p1nn1 _srwzpxbi _18ght94y _1byscs5v"
                ]),
                children: name
            }),
            benefits.map((benefit, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($629e22e9cb1e779a$var$Benefit, {
                    ...benefit
                }, `${benefit.title}-${index}`))
        ]
    });
const $629e22e9cb1e779a$var$CustomersSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const benefits = [
        {
            title: "67%",
            description: intl.formatMessage({
                id: "jira-service-management.customers.benefits.one",
                defaultMessage: "reduction on license costs from switching to Jira Service Management"
            })
        },
        {
            title: "200",
            description: intl.formatMessage({
                id: "jira-service-management.customers.benefits.two",
                defaultMessage: "hours saved a month with report automation"
            })
        },
        {
            title: "100%",
            description: intl.formatMessage({
                id: "jira-service-management.customers.benefits.three",
                defaultMessage: "SLA compliance"
            })
        }
    ];
    const backgroundProperties = {
        textColor: "#ffffff",
        gradientDirection: "180",
        bgColor: "#6554c0",
        bgColor2: "#091e42"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_zrm015vq _1i2c15vq _xsegzu5n _tedvbys6 _11k5vehm _p69cahaf _14ic1nn1 _1b8d1ejb _1m3011ph _1pwq1k8s _1fi2pxbi _13hnowjs _xo3hze3t"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), {
            ...backgroundProperties,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "jsm-customers-section",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        alignItems: "top",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.default), {
                            className: "jsm-customers-header",
                            headerText: intl.formatMessage({
                                id: "jira-service-management.customers.title",
                                defaultMessage: "Teams across the world rely on Jira Service Management"
                            }),
                            headerType: "h2",
                            isCentered: true,
                            ctaProps: {
                                primaryLinkProps: {
                                    text: intl.formatMessage({
                                        id: "jira-service-management.customers.primaryLink",
                                        defaultMessage: "Explore customer stories"
                                    }),
                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/customers"),
                                    type: "primary",
                                    bgColor: "bgBlackBlue",
                                    dataEventProps: {
                                        "data-event-component": "link",
                                        "data-event-container": "customersSection",
                                        "data-event": "clicked",
                                        "data-product-key": "jiraServiceManagement"
                                    }
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                        layout: "7-5",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/10l08o2vaka472w5s7t2xn36574bt4w0.svg",
                                    alt: intl.formatMessage({
                                        id: "jira-service-management.customers.imageAltText",
                                        defaultMessage: "Coworkers collaborating through a series of tasks: documents, charts, video calls, and a service desk"
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)($629e22e9cb1e779a$var$CustomerQuote, {
                                imageLink: "https://dam-cdn.atl.orangelogic.com/AssetLink/7n5j0hqxeq3dci261cgq33ubb03k2886.svg",
                                imageAltText: "Engie",
                                quote: intl.formatMessage({
                                    id: "jira-service-management.customers.quote",
                                    defaultMessage: "\u201CWe needed to move towards a more customer-centric approach on ITSM. Jira Service Management helped us meet our target while saving time and money.\u201D"
                                }),
                                name: intl.formatMessage({
                                    id: "jira-service-management.customers.name",
                                    defaultMessage: "JOSE LUIS LIZ\xc1RRAGA CASTRO, IT SUPPORT ENGINEER, ENGIE MEXICO"
                                }),
                                benefits: benefits
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $fXpYT.PatternLogos), {
                        inlineLogos: $629e22e9cb1e779a$var$inlineLogosProp,
                        className: (0, $esG4f.default)([
                            "_19i01txw _rf0b1g80 _m02rze3t _1rx11h6o _9gf31h6o _18m21wug _o9ht1wug _pcm31wug _1ryj1wug _1xvjuuw1 _llptpxbi _2bc8pxbi _1kxwyfq0 _1vw7glyw _1tgj1osq"
                        ])
                    })
                ]
            })
        })
    });
};
var $629e22e9cb1e779a$export$2e2bcd8739ae039 = $629e22e9cb1e779a$var$CustomersSection;

});
parcelRegister("2pEWv", function(module, exports) {
$parcel$export(module.exports, "PatternLogos", function () { return (parcelRequire("fXpYT")).PatternLogos; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("fXpYT")).PatternLogos; });

var $fXpYT = parcelRequire("fXpYT");

});
parcelRegister("fXpYT", function(module, exports) {

$parcel$export(module.exports, "PatternLogos", function () { return $bc1b089dcaa2a94e$export$355432025e812df1; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");

var $ix9oc = parcelRequire("ix9oc");

var $4XrxY = parcelRequire("4XrxY");
const $bc1b089dcaa2a94e$var$ConditionalLogo = (props)=>{
    if (props.link) return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: props.link,
        className: "logoblock logo-linked",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            src: props.src,
            alt: props.alt,
            width: props.width,
            loading: "lazy"
        })
    });
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        className: "logoblock logo-plain",
        src: props.src,
        alt: props.alt,
        width: props.width,
        loading: "lazy"
    }));
};
const $bc1b089dcaa2a94e$export$355432025e812df1 = ({ inlineLogos: inlineLogos, headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, linkPosition: linkPosition = "top" })=>{
    if (inlineLogos.length < 4 || inlineLogos.length > 12) throw new Error("Minimum 4 logos required, maximum 12");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916ud5o _1nk71e5h _jti51ul9 _xjyridpf _2thuidpf _hbr3idpf",
            className
        ]),
        children: [
            headerText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                    isCentered: true,
                    headerText: headerText,
                    headerType: "h2",
                    eyebrowText: eyebrowText,
                    bodyText: bodyText,
                    ctaProps: linkPosition == "top" && ctaProps?.primaryLinkProps ? ctaProps : undefined
                })
            }) : null,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: `logos-content lgth length-${inlineLogos.length}`,
                    children: inlineLogos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc1b089dcaa2a94e$var$ConditionalLogo, {
                            alt: inlineLogo.alt,
                            src: inlineLogo.src,
                            link: inlineLogo.link,
                            width: inlineLogo.width
                        }, index))
                })
            }),
            footNoteText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: "footnote-text",
                    children: footNoteText
                })
            }) : null,
            linkPosition == "bottom" && ctaProps?.primaryLinkProps ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        ...ctaProps.primaryLinkProps
                    })
                })
            }) : null
        ]
    });
};

});



parcelRegister("h3BeN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a076bf1cdf31cef5$export$2e2bcd8739ae039; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $ix9oc = parcelRequire("ix9oc");

var $3FBn4 = parcelRequire("3FBn4");
const $a076bf1cdf31cef5$var$integrationStyles = null;
const $a076bf1cdf31cef5$var$IntegrationSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _ca0q1ex1 _u5f3idpf _n3td1ex1 _19bvidpf _1itk1ivq _12vervsl _1odr1qro _1o601tuk _p17ahrdt _rb2g1f5y _13hpkf03 _b2g0uoqq _1gauzve2 _1mqf1464 _p2zzrvsl _cuqf3b0z _uhdy16xz _1vq0idpf _1rhy16xz _1awkidpf _1yiofeli _cxtnglwf _19fueva1 _1yduvhbr _11f616xz _cwd6idpf _zi3e16xz _gqjyidpf _16aj7vkz _1c657vkz _8r0m7vkz _1kl67vkz _1piv1ssb _1gq61osq _ut0s16xz _t4tu7vkz _lrqn16xz _15wz7vkz _1chyzwfg _164pidpf _1w7fbys6 _1cz4bys6 _12l4bys6 _qobrvehm _16stvehm _zixkvehm _1h7l1bqd _bbbvbfng _18rf11ph _1jjh1k8s _160adlk8 _1kqodlk8 _1lx8ahaf _110w1mpp _1f5y4jg8 _1525bs82 _1sof1tcg _1gwb1tcg _1xjt1j6v _jpd019bv _ghl3vwuj _1mzy1nn1 _1kblt94y _1a78cs5v _zaid7vkz _7aw719bv _ehlykb7n _1iefidpf _5jj4idpf _1qhkidpf _n3pyidpf _acl8idpf _11sln7od _kfwe1nn1"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: "integrations-content",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                eyebrowText: intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.integrationSection.eyebrow",
                    defaultMessage: "Integrations for every team"
                }),
                headerText: intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.integrationSection.header",
                    defaultMessage: "Supercharge service management with apps and integrations"
                }),
                bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "JiraServiceManagementPageTemplate.integrationSection.body",
                    defaultMessage: "Atlassian Marketplace offers over 1,000 trusted applications and integrations to ensure Jira Service Management can be customized to fit your use case.",
                    values: (0, $3FBn4.DEFAULT_VALUES)
                }),
                headerType: "h2",
                isCentered: true,
                orientation: "vertical",
                ctaProps: {
                    primaryLinkProps: {
                        text: intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.integrationSection.cta",
                            defaultMessage: "Explore the Marketplace"
                        }),
                        href: "https://marketplace.atlassian.com/",
                        type: "primary",
                        dataEventProps: {
                            "data-product-key": "jiraServiceDesk",
                            "data-event-component": "linkButton",
                            "data-event-container": "integrationsSection",
                            "data-event": "clicked"
                        }
                    }
                }
            })
        })
    });
};
var $a076bf1cdf31cef5$export$2e2bcd8739ae039 = $a076bf1cdf31cef5$var$IntegrationSection;

});

parcelRegister("jcaSM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $010f7199a50fafba$export$2e2bcd8739ae039; });
/* scaling.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("37w71");
var $36iSx = parcelRequire("36iSx");
const $010f7199a50fafba$var$jsmScalingSectionStyle = null;
const $010f7199a50fafba$var$ScalingSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1ouu15vq _dbqh15vq _1oz08vuz _1w3uidpf _68j78vuz _oiltidpf _159z1mpp _17aeidpf _eeazidpf _j6onidpf _14qkidpf _sk25d8mv _140edlk8 _1w38bfng _18so1k92 _1goq19ii _1qaibys6 _194zbys6 _43movehm _gnd0vehm _kyhsu67f _1r93u67f _ch5hidpf _x6nlv2br _htkx8vuz _6ctlidpf _14xn8vuz _1jovidpf _i0or1k8s _1vs28vuz _1lfkidpf _74pf8vuz _1chjidpf _rkkeahaf _hocbdlk8 _15wridpf _14ps16xz _1592idpf _dc3e16xz _x0pyidpf _1w0yahaf _la6xd8mv _1pcn1tcg _1ah3idpf _1a5t7vkz _1b6xidpf _j0ch7vkz _1rb1ka7h _pnr8idpf _g12bidpf _26fkidpf _1dhjidpf _1m5dka7h"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $36iSx.SimpleImageTextSide), {
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.scalingHeader",
                defaultMessage: "Jira Service Management scales with you"
            }),
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.scalingBody",
                defaultMessage: "Whether you\u2019re part of a small team or a big enterprise,  we have a plan for you. Choose only the features you need."
            }),
            ctaProps: {
                buttonProps: {
                    text: intl.formatMessage({
                        id: "JiraServiceManagementPageTemplate.scalingCTA",
                        defaultMessage: "Discover plans"
                    }),
                    url: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/pricing"),
                    color: "yellow",
                    className: "jsm-scaling-section-cta",
                    dataEventProps: {
                        "data-event-component": "linkButton",
                        "data-event-container": "linkButton",
                        "data-event": "clicked",
                        "data-label-english": "Discover plans",
                        "data-product-key": "jiraServiceManagement",
                        "data-label": intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.scalingCTA",
                            defaultMessage: "Discover plans"
                        })
                    }
                }
            },
            backgroundColor: "#091e42",
            margin: "0 0",
            className: "jsm-scaling-section",
            imageLink: "https://wac-cdn.atlassian.com/dam/jcr:56da3ff6-b5f2-4b64-815f-5e51867f59de/jsm-features.svg?cdnVersion=1286",
            imageAltText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.awardImageAltText",
                defaultMessage: "Jira Service management features as listed: SLA Management, Chat, Self Service, Queues, Automation, Assets, Atlassian Analytics, Deployment setting, incident investigation, and dynamic forms"
            })
        })
    });
};
var $010f7199a50fafba$export$2e2bcd8739ae039 = $010f7199a50fafba$var$ScalingSection;

});
parcelRegister("37w71", function(module, exports) {
$parcel$export(module.exports, "SimpleImageTextSide", function () { return (parcelRequire("36iSx")).SimpleImageTextSide; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("36iSx")).SimpleImageTextSide; });

var $36iSx = parcelRequire("36iSx");

});
parcelRegister("36iSx", function(module, exports) {

$parcel$export(module.exports, "SimpleImageTextSide", function () { return $724e6fa8a9d5f35b$export$c449191a6146bc15; });
/* simple-image-text-side.tsx generated by @compiled/babel-plugin v0.28.8 */ //@ts-nocheck

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $ix9oc = parcelRequire("ix9oc");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $724e6fa8a9d5f35b$var$simpleImageTextSideStyle = null;
const $724e6fa8a9d5f35b$var$RenderImage = ({ imageLink: imageLink, imageAltText: imageAltText, aspectRatio: aspectRatio })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        },
        className: (0, $esG4f.default)([
            "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _688gkb7n"
        ])
    });
const $724e6fa8a9d5f35b$var$RenderContent = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText, headerType: headerType, lozenge: lozenge, bodyText: bodyText, ctaProps: ctaProps, horizontalRule: horizontalRule, linkText: linkText, linkUrl: linkUrl })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                eyebrowText: eyebrowText,
                headerText: headerText,
                isBannerRichText: isBannerRichText,
                headerType: headerType,
                lozenge: lozenge,
                bodyText: bodyText,
                ctaProps: ctaProps,
                horizontalRule: horizontalRule
            }),
            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                text: linkText,
                href: linkUrl,
                type: "primary"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1jab1ylp _3fdxglyw _5jnq1ylp _uknx7vkz _b9s91ylp"
                ])
            })
        ]
    });
const $724e6fa8a9d5f35b$export$c449191a6146bc15 = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText = false, headerType: headerType = "h2", lozenge: lozenge, bodyText: bodyText, linkText: linkText, linkUrl: linkUrl, imageLink: imageLink, imageAltText: imageAltText, imagePosition: imagePosition, className: className = "", ctaProps: ctaProps, aspectRatio: aspectRatio, horizontalRule: horizontalRule = false, alignItems: alignItems = "center", rowProps: rowProps = "6-6", backgroundColor: backgroundColor = "transparent", margin: margin = "80px 0" })=>{
    const renderImageProps = {
        imageLink: imageLink,
        imageAltText: imageAltText,
        aspectRatio: aspectRatio
    };
    const renderContentProps = {
        eyebrowText: eyebrowText,
        headerText: headerText,
        isBannerRichText: isBannerRichText,
        headerType: headerType,
        lozenge: lozenge,
        bodyText: bodyText,
        ctaProps: ctaProps,
        horizontalRule: horizontalRule,
        linkText: linkText,
        linkUrl: linkUrl
    };
    const first = imagePosition === "left" ? /*#__PURE__*/ (0, $loA2J.jsx)($724e6fa8a9d5f35b$var$RenderImage, {
        ...renderImageProps
    }) : /*#__PURE__*/ (0, $loA2J.jsx)($724e6fa8a9d5f35b$var$RenderContent, {
        ...renderContentProps
    });
    const second = imagePosition === "left" ? /*#__PURE__*/ (0, $loA2J.jsx)($724e6fa8a9d5f35b$var$RenderContent, {
        ...renderContentProps
    }) : /*#__PURE__*/ (0, $loA2J.jsx)($724e6fa8a9d5f35b$var$RenderImage, {
        ...renderImageProps
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _1kmx7vkz _1ggmidpf _1ykz7vkz _1maeidpf _i6jx1wqb _1lh7idpf _z3nc1wqb _wpaiidpf",
            className
        ]),
        style: {
            "--bkgd-color": backgroundColor,
            "--margin": margin,
            "backgroundColor": "var(--bkgd-color, transparent)",
            "margin": "var(--margin, 0)"
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: rowProps,
            alignItems: alignItems,
            children: [
                first,
                second
            ]
        })
    });
};

});



parcelRegister("57Jg1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e977acddc42b1a7d$export$2e2bcd8739ae039; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("6dRh5");
var $dq9mP = parcelRequire("dq9mP");

var $9F3se = parcelRequire("9F3se");
const $e977acddc42b1a7d$var$tabsWrapper = null;
const $e977acddc42b1a7d$var$TabsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const accelerateDevAndOpsLocalizedMedia = {
        videoProps: {
            videoLink: (0, $9F3se.devopsTabSectionVideo)
        }
    };
    const empowerAllServiceTeamsLocalizedMedia = {
        videoProps: {
            videoLink: (0, $9F3se.empowerAllTeamsTabSectionVideo)
        }
    };
    const deliverValueFastLocalizedMedia = {
        videoProps: {
            videoLink: (0, $9F3se.deliverValueFastTabSectionVideo)
        }
    };
    const tabs = [
        {
            textLabel: "Accelerate Dev and Ops",
            id: "tab-accelerate-dev-and-ops",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.plan",
                defaultMessage: "Accelerate Dev and Ops"
            }),
            iconName: "accelerator",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.plan",
                defaultMessage: "Connect Dev and Ops teams on a single AI-powered platform to supercharge collaboration across changes, incidents, and requests - all while managing risk."
            }),
            display: accelerateDevAndOpsLocalizedMedia
        },
        {
            textLabel: "Empower all service teams",
            id: "tab-empower-all-service-teams",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.track",
                defaultMessage: "Empower all service teams"
            }),
            iconName: "team",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.track",
                defaultMessage: "Service management isn\u2019t just for IT. Make it easy for teams across the business - from HR to Legal to Facilities - to streamline requests, centralize knowledge, and work the way they want."
            }),
            display: empowerAllServiceTeamsLocalizedMedia
        },
        {
            textLabel: "Deliver value fast",
            id: "tab-deliver-value-fast",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.release",
                defaultMessage: "Deliver value fast"
            }),
            iconName: "lightning",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.release",
                defaultMessage: "Tune Jira Service Management to your unique requirements - without the complexity of traditional ITSM solutions. Get started fast and and scale as you go, with features like customizable templates, dynamic forms, and AI-powered project configuration."
            }),
            display: deliverValueFastLocalizedMedia
        }
    ];
    const backgroundProperties = {
        textColor: "#ffffff",
        gradientDirection: "180",
        bgColor: "#0049b0",
        bgColor2: "#6554c0"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1ieays9h _182oidpf _vsxzzwfg _1wgpidpf _gng410mc _9wq2ftgi _1khc1y44 _1jsl1ul9 _10xw1y44 _s8o21ul9 _1mxnokh7 _j16mp9y3 _1wiaowjs _19ait94y _119v1ehm _k0231r31 _5wi719ly _ivxy1o36 _15w11k92 _fkt91j28 _63i3idpf _pfqyidpf _en9midpf _wuruidpf _1wbo1mjv _f05r14gx _1oak1osq _h3hm1wug _4qao1wug _1itv1wug _sgdj1wug _dy9hglyw _flua1j6v _x7pi1ylp _he8uidpf _dhofo7ao _11gridpf _h8hfo7ao _hsw71osq _6hns1r31 _1q7419ly _2b7h1o36 _3u8dzwfg _tfcxidpf _112pzwfg _15pjidpf _1jxdv2br _llue1txw _runt1sxn _oeu5idpf _yxrcidpf _y4oridpf _1e45idpf _xpjw19bv _1dv2r5sb _dxdq1msg _158cglyw _vls211p5 _31en1r0c _11051bwz _vat81j6v _1z8av2br _9ik0nl7k _1dnnftgi _pzah1cy2 _rmms1y44 _1rp7utpp _1btk1nn1 _1wkv18xf _1o251tcg _16o51vh9 _1wl62ec4 _120aidpf _1699idpf _jszridpf _18s9idpf _1i23u67f _41r41ssb _if4xor1b _ylm2or1b _19fp1txw _d69b1h6o _1bcz1h6o _1112oelr _17ar1tcg _1u331tcg _11rrahaf _cpc0idpf _1qscidpf _1lvridpf _10lgidpf _1xp91nn1 _16ob1k8s _klrhidpf _1fwiidpf _1py0idpf _1dpdidpf _ndta1td8 _1yr21j6v _1x6p19ii _vn3rbys6 _1i8cvehm _9zi31k92 _s4ue1k92"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), {
            ...backgroundProperties,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dq9mP.TabsQuote), {
                id: "tabs-section",
                label: "Tabs",
                headerText: intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.tabsHeader",
                    defaultMessage: "High-velocity service management"
                }),
                bodyText: "",
                tabs: tabs,
                colors: {
                    defaultBG: "#ffffff",
                    defaultText: "#5e6c84",
                    activeBG: "#deebff",
                    activeText: "#091e42",
                    hoverBG: "#ffffff",
                    hoverText: "#5e6c84"
                },
                className: "jira-service-management-tabs"
            })
        })
    });
};
var $e977acddc42b1a7d$export$2e2bcd8739ae039 = $e977acddc42b1a7d$var$TabsSection;

});
parcelRegister("6dRh5", function(module, exports) {
$parcel$export(module.exports, "TabsQuote", function () { return (parcelRequire("dq9mP")).TabsQuote; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("dq9mP")).TabsQuote; });

var $dq9mP = parcelRequire("dq9mP");

});
parcelRegister("dq9mP", function(module, exports) {

$parcel$export(module.exports, "TabsQuote", function () { return $c80b07db157526ca$export$ad1b9d9a70aaa9a5; });
/* tabs-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $ix9oc = parcelRequire("ix9oc");

var $gXzhc = parcelRequire("gXzhc");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $c80b07db157526ca$var$StatsStyle = null;
const $c80b07db157526ca$var$TabsWrapper = null;
const $c80b07db157526ca$export$ad1b9d9a70aaa9a5 = ({ id: id, label: label, headerText: headerText, bodyText: bodyText, tabs: tabs, colors: colors, ctaProps: ctaProps, linkPosition: linkPosition = "bottom", className: className, tabContentType: tabContentType = "quoteTextImage" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_syazu67f _ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                    className: "tabs-quote-header-content-block",
                    headerText: headerText,
                    headerType: "h2",
                    bodyText: bodyText,
                    isCentered: true,
                    ctaProps: linkPosition == "top" && ctaProps?.primaryLinkProps ? ctaProps : {}
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ca0qgktf _u5f3idpf _n3tdgktf _19bvidpf",
                    "tabquote-tab-group-div"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gXzhc.TabGroup), {
                    colors: colors,
                    tabContentType: tabContentType,
                    tabs: tabs,
                    id: id,
                    label: label
                })
            }),
            linkPosition == "bottom" && ctaProps?.primaryLinkProps ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        ...ctaProps.primaryLinkProps
                    })
                })
            }) : null
        ]
    });
};

});


parcelRegister("9F3se", function(module, exports) {

$parcel$export(module.exports, "devopsTabSectionVideo", function () { return $56da178ed9f9074d$export$53481b52861292a7; });
$parcel$export(module.exports, "empowerAllTeamsTabSectionVideo", function () { return $56da178ed9f9074d$export$3e38b0232a5e801; });
$parcel$export(module.exports, "deliverValueFastTabSectionVideo", function () { return $56da178ed9f9074d$export$bbcf3da58a2469ed; });
// no localized image for hu, it, ko, nl, pl, zh, de, es, fr, ja, br, ru
const $56da178ed9f9074d$var$heroSectionImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:de1966b5-df25-4e7c-8477-ebd8456930c5/jsm-hero-portal.png?cdnVersion=1276"
};
const $56da178ed9f9074d$export$55b4ecbb6fe6298e = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $56da178ed9f9074d$var$heroSectionImageMap[locale] || $56da178ed9f9074d$var$heroSectionImageMap["en"];
};
const $56da178ed9f9074d$export$53481b52861292a7 = "https://dam-cdn.atl.orangelogic.com/AssetLink/8b6d8j2j8bot6l8753taue84xgmdilnt.mp4";
const $56da178ed9f9074d$export$3e38b0232a5e801 = "https://dam-cdn.atl.orangelogic.com/AssetLink/qk55334yq4gd01k1581083dshd3p3d27.mp4";
const $56da178ed9f9074d$export$bbcf3da58a2469ed = "https://dam-cdn.atl.orangelogic.com/AssetLink/0b3qjw6u11w3520ch250j22130hdtc6e.mp4";

});


parcelRegister("daXMt", function(module, exports) {

$parcel$export(module.exports, "Team25LiftedBanner", function () { return $2ebceaff01ed0114$export$29ddea6c252c2806; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $kwHar = parcelRequire("kwHar");

var $3FBn4 = parcelRequire("3FBn4");

var $47768 = parcelRequire("47768");

var $9iWJ8 = parcelRequire("9iWJ8");
const $2ebceaff01ed0114$export$29ddea6c252c2806 = (props)=>{
    const { testGwp5090BannerExperiment: testGwp5090BannerExperiment } = props;
    const intl = (0, $f6qj2.default)();
    const gwp5090BannerExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp5090ExperimentBannerJSM);
    const gwp5090IsLiftedBanner = testGwp5090BannerExperiment || gwp5090BannerExperiment != undefined && gwp5090BannerExperiment.type === "enrolled" && gwp5090BannerExperiment.value === "lifted";
    const gwp5090Team25Config = {
        identifier: "GWP5090.jsm-product-tour.lifted",
        bannerType: "lifted",
        customCSS: {
            marginBottom: (0, $kwHar.default)("space.600")
        },
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "team25-banners-and-butterbars.jsm.text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Be the first to demo our latest AI innovations and deliver game-changing experiences at Team \u201925!",
                values: (0, $3FBn4.DEFAULT_VALUES)
            })
        }),
        mobileText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "team25-banners-and-butterbars.jsm.mobile-text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Demo our latest AI tools at Team \u201925!",
                values: (0, $3FBn4.DEFAULT_VALUES)
            })
        }),
        productKey: "home",
        backgroundPreset: "gwp-5090-banners",
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/gf1wkse40oux4nf58b103kknvb18p4yc.webp",
            alt: "Team25",
            //Event name is not localized
            width: 200
        },
        linkText: "Get your pass",
        linkUrl: "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=jsm_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=lifted-bar_WEBTEAM-17396&event_id=216653",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "team25-banners-and-butterbars.jsm.cta",
                defaultMessage: "Get your pass"
            }),
            "data-label-english": "Get your pass"
        }
    };
    if (gwp5090IsLiftedBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $47768.EnhancedBannerAlert), {
        ...gwp5090Team25Config
    });
    return null;
};

});

parcelRegister("4QWpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68c22b264f35d83$export$2e2bcd8739ae039; });
/* tiles.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $ix9oc = parcelRequire("ix9oc");

var $4XrxY = parcelRequire("4XrxY");

var $jChL3 = parcelRequire("jChL3");

var $jzN8u = parcelRequire("jzN8u");

var $1PkYS = parcelRequire("1PkYS");

var $kUFbA = parcelRequire("kUFbA");

var $9iiSH = parcelRequire("9iiSH");

var $bnvPE = parcelRequire("bnvPE");

var $gCrEB = parcelRequire("gCrEB");

var $2u0KA = parcelRequire("2u0KA");

var $hDRjU = parcelRequire("hDRjU");

var $lY0C7 = parcelRequire("lY0C7");
const $a68c22b264f35d83$var$tilesStyles = null;
const $a68c22b264f35d83$var$templateCardContainer = null;
const $a68c22b264f35d83$var$headerRow = null;
const $a68c22b264f35d83$var$getFeaturedTemplates = (intl, learnMoreLabel)=>[
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9iiSH.CogsIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.itsm.title",
                defaultMessage: "ITSM"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.itsm.name",
                defaultMessage: "IT service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.itsm.description",
                defaultMessage: "Manage requests, incidents, and changes to deliver great service, fast."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.itsm.try",
                defaultMessage: "Try the ITSM template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-it-service-management-basic",
            learnMoreLink: "/software/jira/templates/it-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#998dd9"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hDRjU.SmileyIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.customer-service.title",
                defaultMessage: "Customer service"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.customer-service.name",
                defaultMessage: "Customer service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.customer-service.description",
                defaultMessage: "Deliver great service experiences to external customers, fast."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.customer-service.try",
                defaultMessage: "Try the customer service template"
            }),
            templateId: "com.atlassian.servicedesk:next-gen-external-service-desk",
            learnMoreLink: "/software/jira/templates/customer-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#4c9aff"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2u0KA.PeopleIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.hr.title",
                defaultMessage: "Human resources"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.hr.name",
                defaultMessage: "HR service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.hr.description",
                defaultMessage: "Manage onboarding and offboarding and respond to staff requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.hr.try",
                defaultMessage: "Try the HR template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-hr-service-desk",
            learnMoreLink: "/software/jira/templates/hr-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#0065ff"
        }
    ];
const $a68c22b264f35d83$var$getMoreTemplates = (intl, learnMoreLabel)=>[
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gCrEB.LightIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.facilities.title",
                defaultMessage: "Facilities"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.facilities.name",
                defaultMessage: "Facilities service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.facilities.description",
                defaultMessage: "Manage requests for maintenance, moving, and event planning."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.facilities.try",
                defaultMessage: "Try the facilities template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-facilities-service-desk",
            learnMoreLink: "/software/jira/templates/facilities-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#6554c0"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1PkYS.BriefCaseIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.legal.title",
                defaultMessage: "Legal"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.legal.name",
                defaultMessage: "Legal service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.legal.description",
                defaultMessage: "Create, manage, and track your contracts."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.legal.try",
                defaultMessage: "Try the legal template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-legal-service-desk",
            learnMoreLink: "/software/jira/templates/legal-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#8777d9"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bnvPE.DollarIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.finance.title",
                defaultMessage: "Finance"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.finance.name",
                defaultMessage: "Finance service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.finance.description",
                defaultMessage: "Manage budget, spend, and other finance requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.finance.try",
                defaultMessage: "Try the finance template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-finance-service-desk",
            learnMoreLink: "/software/jira/templates/finance-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#0065ff"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kUFbA.BullHornIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.marketing.title",
                defaultMessage: "Marketing"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.marketing.name",
                defaultMessage: "Marketing service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.marketing.description",
                defaultMessage: "Manage and track all your marketing requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.marketing.try",
                defaultMessage: "Try the marketing template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-marketing-service-desk",
            learnMoreLink: "/software/jira/templates/marketing-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#4c9aff"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lY0C7.StarIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.design.title",
                defaultMessage: "Design"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.design.name",
                defaultMessage: "Design service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.design.description",
                defaultMessage: "Easily manage and track all kinds of design requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.design.try",
                defaultMessage: "Try the design template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-design-service-desk",
            learnMoreLink: "/software/jira/templates/design-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#6554c0"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jzN8u.BagIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.sales.title",
                defaultMessage: "Sales"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.sales.name",
                defaultMessage: "Sales service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.sales.description",
                defaultMessage: "Manage, track, and report on sales requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.sales.try",
                defaultMessage: "Try the sales template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-sales-service-desk",
            learnMoreLink: "/software/jira/templates/sales-service-management",
            learnMoreLabel: learnMoreLabel,
            barColor: "#4c9aff"
        }
    ];
const $a68c22b264f35d83$var$TilesSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const [isExpanded, setIsExpanded] = (0, $iSvIT.useState)(false);
    const toggleShowMore = ()=>{
        setIsExpanded(!isExpanded);
    };
    const showMore = intl.formatMessage({
        id: "JiraServiceManagementPageTemplate.templatesSection.showMore",
        defaultMessage: "Show more"
    });
    const showLess = intl.formatMessage({
        id: "JiraServiceManagementPageTemplate.templatesSection.showLess",
        defaultMessage: "Show less"
    });
    const learnMore = intl.formatMessage({
        id: "JiraServiceManagementPageTemplate.templatesSection.learnMore",
        defaultMessage: "Learn more"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1yag1a1f _1itkt5k3 _ouxl1nty _12vemgnk _1lrw174u _6ssjn9zw _tlqvxncg _o4gw18qk _5kkl1k8s _lgdadlk8 _8mutze3t _199z1wug _jy1d1wug _s3ns1wug _3ojx1wug _koa4bys6 _ohp0bys6 _ula8bys6 _n202vehm _1p4dvehm _17e6vehm _x0jlahaf _k9hsqgjj _py051bqd _16h91tcg _1je8bfng _1huepxbi _6o5svwuj _1u7l1tcg _1qrt4jg8 _1oyn1k92 _mn5y19ii _1wf0yvqg _1o0mze3t _146c1osq _2i3n1k8s _drrhdlk8 _1lzoze3t _4rxo1jx0 _xoz6idpf _1eqoidpf _kebgidpf _1sxvidpf _126h1y44 _esg819bv _7atg1y44 _an1019bv _1s081nn1 _12y1n7od _vx12glyw _nr8zglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _p12f1fra _19pk1wug _2hwx1wug _otyr1wug _18u01wug _6ssj1cfz"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                        className: "templates-header-content",
                        headerText: intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.templatesSection.header",
                            defaultMessage: "Get started quickly with templates"
                        }),
                        bodyText: intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.templatesSection.body",
                            defaultMessage: "With pre-configured request types, workflows and other out-of-the-box capabilities, templates make it easy for any team to get started quickly with a service experience that fits the way they like to work."
                        }),
                        headerType: "h2",
                        isCentered: true,
                        orientation: "vertical"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1fra _zulpxy5q _1j8bz7l7 _19d7i47z"
                    ]),
                    children: $a68c22b264f35d83$var$getFeaturedTemplates(intl, learnMore).map((template)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jChL3.default), {
                            ...template
                        }, template.title))
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                    className: "templates-show-more-content",
                    headerText: "",
                    bodyText: "",
                    headerType: "h2",
                    isCentered: true,
                    orientation: "vertical",
                    ctaProps: {
                        primaryLinkProps: {
                            text: isExpanded ? showLess : showMore,
                            href: "",
                            type: "anchor",
                            onClick (e) {
                                e.preventDefault();
                                toggleShowMore();
                            }
                        }
                    }
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1fra _zulpxy5q _1j8bz7l7 _19d7i47z"
                    ]),
                    children: $a68c22b264f35d83$var$getMoreTemplates(intl, learnMore).map((template)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jChL3.default), {
                            ...template
                        }, template.title))
                })
            })
        ]
    });
};
var $a68c22b264f35d83$export$2e2bcd8739ae039 = $a68c22b264f35d83$var$TilesSection;

});
parcelRegister("jChL3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5929061eb58f7ee6$export$2e2bcd8739ae039; });
/* template-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");
const $5929061eb58f7ee6$var$cardStyles = null;
const $5929061eb58f7ee6$var$cardIconStyles = null;
const $5929061eb58f7ee6$var$cardHeading3Styles = null;
const $5929061eb58f7ee6$var$cardParagraphStyles = null;
const $5929061eb58f7ee6$var$cardAnchorStyles = null;
const $5929061eb58f7ee6$var$TemplateCard = (props)=>{
    const { icon: icon, title: title, name: name, description: description, try: tryText, templateId: templateId, learnMoreLink: learnMoreLink, learnMoreLabel: learnMoreLabel, barColor: barColor } = props;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const handleClicked = (event)=>{
        event.preventDefault();
        openModalForTemplate({
            templateId: templateId,
            templateName: name,
            productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        style: {
            borderTopColor: barColor || "transparent"
        },
        className: (0, $esG4f.default)([
            "_bfhku67f _2rko1l7b _16qso5yx _7mya19bv _1sw7nqa1 _6rthu2gc _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1e5h _1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor || "transparent"
                },
                className: (0, $esG4f.default)([
                    "_2rko1ssb _1yt4pxbi _1bsbvbgk _4t3ivbgk _6rthpxbi"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_syaz1bqd _1e0c1ule _1wyb1k8s _k48pbfng _vwz4xy5q _85i5pxbi _18s8ze3t _so7d1k92"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wybpxbi _k48p1nn1 _vwz4v47k _6rth1ejb"
                ]),
                children: description
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                href: "",
                onClick: handleClicked,
                text: tryText,
                type: "external",
                className: (0, $esG4f.default)([
                    "_1d61glyw _rfqo1r31 _1bgk8stv _1t0pnqa1 _18smglyw _9m7f1r31 _w7sw8stv _15a9nqa1 _1wl11tcg",
                    "try-link"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                href: (0, $3FBn4.useLocalizedHref)(learnMoreLink),
                text: learnMoreLabel,
                type: "primary",
                className: (0, $esG4f.default)([
                    "_1d61glyw _rfqo1r31 _1bgk8stv _1t0pnqa1 _18smglyw _9m7f1r31 _w7sw8stv _15a9nqa1 _1wl11tcg"
                ])
            })
        ]
    });
};
var $5929061eb58f7ee6$export$2e2bcd8739ae039 = $5929061eb58f7ee6$var$TemplateCard;

});

parcelRegister("jzN8u", function(module, exports) {

$parcel$export(module.exports, "BagIcon", function () { return $d6c6c8cb527b2fbd$export$814ad7f304620551; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $d6c6c8cb527b2fbd$export$814ad7f304620551 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffffff",
                fillRule: "evenodd",
                d: "M28.31,36a4.19,4.19,0,0,0,4.19-4.19V2.1A2.09,2.09,0,0,0,30.41,0H5.59A2.09,2.09,0,0,0,3.5,2.1V31.81A4.19,4.19,0,0,0,7.69,36ZM11,6.92A1.58,1.58,0,0,1,14.16,7V15.3a3.84,3.84,0,0,0,7.68-.1V6.92A1.57,1.57,0,0,1,25,7v8.33a7,7,0,0,1-14-.12V6.92Z"
            })
        })
    });
};

});
parcelRegister("1ui6x", function(module, exports) {

$parcel$export(module.exports, "SvgContainer", function () { return $246ba33ae1756725$export$483e7437cf07e16f; });
/* svg-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $246ba33ae1756725$export$483e7437cf07e16f = (props)=>{
    const styles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1ii71ule _1i4xidpf _w8l51osq _4x2014no"
        ]),
        children: props.children
    });
};

});


parcelRegister("1PkYS", function(module, exports) {

$parcel$export(module.exports, "BriefCaseIcon", function () { return $77b53d826cd6ac42$export$8219767dc2711cb7; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $77b53d826cd6ac42$export$8219767dc2711cb7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M12.06,6.06a6.06,6.06,0,1,1,12.11,0v2h-3v-2A3,3,0,0,0,18.2,3h-.09a3,3,0,0,0-3,3v2h-3ZM19.8,17.5H35.27V32a4,4,0,0,1-4,4H4.66a4,4,0,0,1-4-4V17.5H16.77v2.18a1.52,1.52,0,1,0,3,0Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M35.27,12.11a4,4,0,0,0-4-4H4.66a4,4,0,0,0-4,4V17.5H16.77V14.63a1.52,1.52,0,0,1,3,0V17.5H35.27Z"
                })
            ]
        })
    });
};

});

parcelRegister("kUFbA", function(module, exports) {

$parcel$export(module.exports, "BullHornIcon", function () { return $782cc9ea2315769a$export$ed69ce0c0a77942b; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $782cc9ea2315769a$export$ed69ce0c0a77942b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M22.35,29.44a3.61,3.61,0,0,1-7.22,0V25.6l-2.94-.86c0,.09,0,.18,0,.27v4.43a6.56,6.56,0,0,0,13.12,0v-.88l-2.95-.86Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M1.84,12.22l1.48-.58v-.15a1.48,1.48,0,0,0-2.95.07v10.9a1.48,1.48,0,0,0,2.95-.07v-.23l-1.48-.43Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M33,.14,3.32,11.64l-1.48.58v9.51l1.48.43,8.87,2.58,2.94.86,7.22,2.1,2.95.86,7.81,2.28A2,2,0,0,0,35.63,29V2A2,2,0,0,0,33,.14Z"
                })
            ]
        })
    });
};

});

parcelRegister("9iiSH", function(module, exports) {

$parcel$export(module.exports, "CogsIcon", function () { return $590076bd21792b42$export$a5f9db729434ffda; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $590076bd21792b42$export$a5f9db729434ffda = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M14.36,13.27a1.49,1.49,0,0,0-1.49-1.49H11.32a1.49,1.49,0,0,0-1.49,1.49v1.82a8.76,8.76,0,0,0-2.34,1L6.2,14.78a1.48,1.48,0,0,0-2.11,0L3,15.87A1.48,1.48,0,0,0,3,18l1.28,1.29a8.76,8.76,0,0,0-1,2.34H1.49A1.49,1.49,0,0,0,0,23.1v1.55a1.49,1.49,0,0,0,1.49,1.49H3.31a8.63,8.63,0,0,0,1,2.34L3,29.77a1.48,1.48,0,0,0,0,2.11L4.09,33A1.5,1.5,0,0,0,6.2,33l1.29-1.29a8.76,8.76,0,0,0,2.34,1v1.82A1.49,1.49,0,0,0,11.32,36h1.55a1.49,1.49,0,0,0,1.49-1.49V32.66a8.63,8.63,0,0,0,2.34-1L18,33a1.5,1.5,0,0,0,2.11,0l1.1-1.1a1.5,1.5,0,0,0,0-2.11l-1.29-1.29a8.63,8.63,0,0,0,1-2.34H22.7a1.49,1.49,0,0,0,1.49-1.49V23.1a1.49,1.49,0,0,0-1.49-1.49H20.88a8.76,8.76,0,0,0-1-2.34L21.2,18a1.5,1.5,0,0,0,0-2.11l-1.1-1.09a1.48,1.48,0,0,0-2.11,0L16.7,16.06a8.63,8.63,0,0,0-2.34-1ZM12.1,19.89a4,4,0,1,1-4,4A4,4,0,0,1,12.1,19.89Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M31.74,1.88A1.09,1.09,0,0,0,31.1.49L30.05.1a1.08,1.08,0,0,0-1.39.62L28.2,2A6.22,6.22,0,0,0,26.37,2L25.82.81A1.09,1.09,0,0,0,24.39.27l-1,.46a1.08,1.08,0,0,0-.53,1.43l.55,1.19a6.87,6.87,0,0,0-1.25,1.33l-1.23-.46a1.08,1.08,0,0,0-1.39.63l-.39,1a1.08,1.08,0,0,0,.64,1.39L21,7.74a6.57,6.57,0,0,0,.07,1.83l-1.19.54a1.08,1.08,0,0,0-.54,1.43l.47,1a1.08,1.08,0,0,0,1.44.54l1.19-.54a6.42,6.42,0,0,0,1.34,1.26L23.33,15A1.08,1.08,0,0,0,24,16.42l1,.39a1.07,1.07,0,0,0,1.39-.62L26.86,15a6.57,6.57,0,0,0,1.83-.05l.55,1.19a1.09,1.09,0,0,0,1.43.54l1-.46a1.07,1.07,0,0,0,.53-1.43l-.54-1.19a6.28,6.28,0,0,0,1.24-1.33l1.23.46a1.07,1.07,0,0,0,1.39-.63l.39-1a1.08,1.08,0,0,0-.64-1.39l-1.23-.46A6.22,6.22,0,0,0,34,7.34l1.2-.54a1.06,1.06,0,0,0,.53-1.42l-.47-1a1.09,1.09,0,0,0-1.43-.54l-1.2.54a6.38,6.38,0,0,0-1.34-1.25ZM27.8,5.15a3.37,3.37,0,0,1,3.07,3.61,3.3,3.3,0,0,1-3.61,3,3.37,3.37,0,0,1-3.07-3.61A3.3,3.3,0,0,1,27.8,5.15Z"
                })
            ]
        })
    });
};

});

parcelRegister("bnvPE", function(module, exports) {

$parcel$export(module.exports, "DollarIcon", function () { return $6091cbd8cf820a17$export$e69f65903d0e6829; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $6091cbd8cf820a17$export$e69f65903d0e6829 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffffff",
                fillRule: "evenodd",
                d: "M23,12.65a1.23,1.23,0,0,0,2.45-.06V11.15a7.45,7.45,0,0,0-6.22-7.22V1.17a1.23,1.23,0,0,0-2.46.06v2.7a7.43,7.43,0,0,0-6.22,7.34v.63A7.44,7.44,0,0,0,18,19.23h.09a5,5,0,0,1,4.91,5v.59a5,5,0,0,1-10-.09V23.35a1.23,1.23,0,0,0-2.45.06v1.44a7.45,7.45,0,0,0,6.22,7.22v2.76a1.23,1.23,0,0,0,2.46-.06v-2.7a7.43,7.43,0,0,0,6.22-7.34V24.1A7.44,7.44,0,0,0,18,16.77h-.09a5,5,0,0,1-4.91-5v-.59a5,5,0,0,1,10,.09v1.38Z"
            })
        })
    });
};

});

parcelRegister("gCrEB", function(module, exports) {

$parcel$export(module.exports, "LightIcon", function () { return $89810a220c6c05e6$export$82acdd66a4e4bf90; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $89810a220c6c05e6$export$82acdd66a4e4bf90 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M14.17,32.08A3.93,3.93,0,0,0,18.09,36h.12a3.93,3.93,0,0,0,3.93-3.92V32h-8Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M19.7,11.14V1.63a1.7,1.7,0,0,0-3.39.07v9.55a4.78,4.78,0,0,1,3.4-.11Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M23.05,18.82v-3a4.88,4.88,0,0,0-3.35-4.65,4.78,4.78,0,0,0-3.4.11,4.89,4.89,0,0,0-3.05,4.54v3A13.46,13.46,0,0,0,2.23,32l0,0h31.5l0,0A13.45,13.45,0,0,0,23.05,18.82Zm4.29,9.68A1.39,1.39,0,0,1,26,27.18v-.06a2.44,2.44,0,0,0-2.37-2.45h-.08a1.38,1.38,0,1,1,0-2.76,5.21,5.21,0,0,1,5.21,5.21A1.38,1.38,0,0,1,27.34,28.5Z"
                })
            ]
        })
    });
};

});

parcelRegister("2u0KA", function(module, exports) {

$parcel$export(module.exports, "PeopleIcon", function () { return $e8bf63e7ff55672a$export$a0096b57009ecc7c; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $e8bf63e7ff55672a$export$a0096b57009ecc7c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M10.84,28.07V24.36a5.57,5.57,0,0,1,1.74-4.05A5.57,5.57,0,0,0,8.7,18.75H5.61A5.61,5.61,0,0,0,0,24.36v3.71a1,1,0,0,0,1,1H11.82A1,1,0,0,1,10.84,28.07Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M7.16,17.47A4.12,4.12,0,1,0,3,13.35,4.12,4.12,0,0,0,7.16,17.47Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M30.39,18.75H27.3a5.57,5.57,0,0,0-3.88,1.56,5.57,5.57,0,0,1,1.74,4.05v3.71a1,1,0,0,1-1,1H35a1,1,0,0,0,1-1V24.36A5.61,5.61,0,0,0,30.39,18.75Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M28.84,17.47a4.12,4.12,0,1,0-4.12-4.12A4.11,4.11,0,0,0,28.84,17.47Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M14.85,10.72a4.08,4.08,0,0,0-.92,2.58.43.43,0,0,1,0,0h4a.65.65,0,0,0,.52-.26l.93-1.24a.22.22,0,0,1,.35,0l.93,1.24a.68.68,0,0,0,.53.26h.91a.43.43,0,0,1,0,0A4.07,4.07,0,0,0,18,9.23a4.41,4.41,0,0,0-.52,0,2,2,0,0,0,0-.36,2,2,0,1,0-2.66,1.82Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M23.42,20.31a5.55,5.55,0,0,0-3.87-1.57H16.46a5.65,5.65,0,0,0-5.62,5.62v4.69H24.18a1,1,0,0,0,1-1V24.36A5.57,5.57,0,0,0,23.42,20.31Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M20.62,13.09l-.93-1.24a.22.22,0,0,0-.35,0l-.93,1.24a.65.65,0,0,1-.52.26h-4a1,1,0,0,0,0,.17,1.62,1.62,0,0,0,0,.22l0,.19,0,.21c0,.06,0,.12.05.19s0,.13,0,.2l.07.18.07.19.09.17.08.18.11.17a1.4,1.4,0,0,0,.1.16l.12.17a1.71,1.71,0,0,0,.11.14l.14.16.12.13.16.15a.69.69,0,0,1,.13.11l.19.14.12.09.21.13.13.07a1.67,1.67,0,0,0,.23.12l.12.05.28.11.09,0,.35.09h0a4.47,4.47,0,0,0,.82.08,4,4,0,0,0,1.21-.18h0l.34-.13.06,0,.3-.15.06,0,.27-.16.07-.05.24-.18.08-.07.21-.19.07-.08.19-.21.07-.09.17-.22.06-.11.14-.22.06-.13a1.63,1.63,0,0,0,.11-.23s0-.09.05-.13l.09-.24a.83.83,0,0,1,0-.15l.06-.24L22,14l0-.24a.91.91,0,0,0,0-.17,1.48,1.48,0,0,0,0-.21h-.91A.68.68,0,0,1,20.62,13.09Z"
                })
            ]
        })
    });
};

});

parcelRegister("hDRjU", function(module, exports) {

$parcel$export(module.exports, "SmileyIcon", function () { return $fb758fd81d573888$export$663870aff582477c; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $fb758fd81d573888$export$663870aff582477c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M0,18A18,18,0,1,1,18,36,18,18,0,0,1,0,18Zm33.18,0A15.18,15.18,0,1,0,18,33.18,15.17,15.17,0,0,0,33.18,18Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M9.28,19.65a1.41,1.41,0,0,1,1.81.84,7.43,7.43,0,0,0,13.82,0,1.41,1.41,0,1,1,2.65,1,10.25,10.25,0,0,1-19.12,0A1.41,1.41,0,0,1,9.28,19.65Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                    cx: "12.21",
                    cy: "13.77",
                    r: "2.66",
                    fill: "#ffffff",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                    cx: "24.1",
                    cy: "13.77",
                    r: "2.66",
                    fill: "#ffffff",
                    fillRule: "evenodd"
                })
            ]
        })
    });
};

});

parcelRegister("lY0C7", function(module, exports) {

$parcel$export(module.exports, "StarIcon", function () { return $d728d2964c6c6969$export$2ee28caa7f1e962e; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $d728d2964c6c6969$export$2ee28caa7f1e962e = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffffff",
                fillRule: "evenodd",
                d: "M14.75,2.7,11.15,10l-8,1.18A3.56,3.56,0,0,0,1,12.23L1,12.32a3.62,3.62,0,0,0,.14,5l5.83,5.69-1.38,8a3.68,3.68,0,0,0,.37,2.3l0,.09a3.62,3.62,0,0,0,4.84,1.43L18,31.12l7.2,3.79a3.6,3.6,0,0,0,2.3.36l.1,0a3.62,3.62,0,0,0,2.86-4.16l-1.38-8,5.83-5.69A3.56,3.56,0,0,0,36,15.29l0-.11a3.63,3.63,0,0,0-3.08-4l-8-1.18-3.6-7.3a3.62,3.62,0,0,0-6.5,0Z"
            })
        })
    });
};

});





parcelRegister("bfGvY", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $831212f3b8a942df$var$hasElementType = typeof Element !== "undefined";
var $831212f3b8a942df$var$hasMap = typeof Map === "function";
var $831212f3b8a942df$var$hasSet = typeof Set === "function";
var $831212f3b8a942df$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $831212f3b8a942df$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$831212f3b8a942df$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($831212f3b8a942df$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$831212f3b8a942df$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($831212f3b8a942df$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($831212f3b8a942df$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($831212f3b8a942df$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$831212f3b8a942df$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $831212f3b8a942df$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("lzzak", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $fb482505c2962b4d$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $fb482505c2962b4d$export$bb5ca5fba6fb4f1f; });

var $iSvIT = parcelRequire("iSvIT");

var $2mGe8 = parcelRequire("2mGe8");
var $fb482505c2962b4d$var$generateUID = function(context) {
    var quartz = context || (0, $2mGe8.counter);
    var prefix = (0, $2mGe8.getPrefix)(quartz);
    var id = (0, $2mGe8.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $fb482505c2962b4d$var$useUIDState = function() {
    var context = (0, $iSvIT.useContext)((0, $2mGe8.source));
    var uid = (0, $iSvIT.useState)(function() {
        return $fb482505c2962b4d$var$generateUID(context);
    })[0];
    return uid;
};
var $fb482505c2962b4d$export$87d05f07e65211f1 = function() {
    var uid = $fb482505c2962b4d$var$useUIDState().uid;
    return uid;
};
var $fb482505c2962b4d$export$bb5ca5fba6fb4f1f = function() {
    var gen = $fb482505c2962b4d$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("2mGe8", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $1b8e643ba833cfcb$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $1b8e643ba833cfcb$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $1b8e643ba833cfcb$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $1b8e643ba833cfcb$export$36e24695f02d4503; });

var $iSvIT = parcelRequire("iSvIT");

var $cFJ5y = parcelRequire("cFJ5y");
var $1b8e643ba833cfcb$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $cFJ5y.generateUID)()
    };
};
var $1b8e643ba833cfcb$export$e575061ef2a070eb = $1b8e643ba833cfcb$export$1921362e86c73c88();
var $1b8e643ba833cfcb$export$b4d5da5f34fb77ad = $iSvIT.createContext($1b8e643ba833cfcb$export$1921362e86c73c88());
var $1b8e643ba833cfcb$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $1b8e643ba833cfcb$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});


parcelRegister("fxdfZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b48c91a1934e1c$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $1xv8a = parcelRequire("1xv8a");
class $b2b48c91a1934e1c$export$2e2bcd8739ae039 extends (0, $iSvIT.Component) {
    constructor(props){
        super(props);
        /** In the event that we only want to show a fallback for a specific error,
   * we can pass a function to shouldShowFallback that will determine if the fallback should be shown
   * Returns true if shouldShowFallback is not provided or if the function returns true
   **/ this.shouldRenderFallback = ()=>{
            if (!this.state.error) return false;
            if (!this.props.shouldShowFallback) return true;
            return this.props.shouldShowFallback(this.state.error);
        };
        this.state = {};
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Call onError callback if provided
        this.props.onError?.(error, info);
        // Log the error
        (0, $1xv8a.Helpers).sendWrapperLoadError(error.message, info.componentStack ?? undefined);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        if (this.shouldRenderFallback()) return fallback;
        return children;
    }
}

});

parcelRegister("bZcXh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b9f70d243a7264d$export$2e2bcd8739ae039; });
function $8b9f70d243a7264d$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("cQk7Y", function(module, exports) {

$parcel$export(module.exports, "ALGOLIA_APP_ID", function () { return $bfeeaa29e3f9a245$export$17b978e8ab9e4c58; });
$parcel$export(module.exports, "ALGOLIA_SEARCH_API_KEY", function () { return $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1; });
$parcel$export(module.exports, "ALGOLIA_FACET_KEY", function () { return $bfeeaa29e3f9a245$export$b23c3af39ccf497d; });
$parcel$export(module.exports, "activeSearchIndex", function () { return $bfeeaa29e3f9a245$export$e9dac33bbaf86e02; });
$parcel$export(module.exports, "activeSearchIndexV3", function () { return $bfeeaa29e3f9a245$export$b337d69b7a65e111; });
$parcel$export(module.exports, "AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY", function () { return $bfeeaa29e3f9a245$export$5049c8654c52de2a; });
$parcel$export(module.exports, "sendConversionEventAlgolia", function () { return $bfeeaa29e3f9a245$export$b887d873139badc3; });
$parcel$export(module.exports, "handleAlgoliaConversionMetrics", function () { return $bfeeaa29e3f9a245$export$120e7b764d5fde54; });
$parcel$export(module.exports, "useA11yDropdownAnnouncement", function () { return $bfeeaa29e3f9a245$export$3d596a295dd7fc61; });
$parcel$export(module.exports, "HiddenAriaLiveAnnouncement", function () { return $bfeeaa29e3f9a245$export$e96bd116e2b4049a; });
/* auto-complete-helpers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $2bsWQ = parcelRequire("2bsWQ");

var $f6qj2 = parcelRequire("f6qj2");

var $gFK1O = parcelRequire("gFK1O");

var $1syhO = parcelRequire("1syhO");
const $bfeeaa29e3f9a245$export$17b978e8ab9e4c58 = "CU5KFWE75C";
const $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1 = "8cb0497a0549da256319b1b8178e5421";
const $bfeeaa29e3f9a245$export$b23c3af39ccf497d = "category";
const $bfeeaa29e3f9a245$export$74b39503c55b7612 = "www.atlassian.com.v2";
const $bfeeaa29e3f9a245$export$5b7165c5ebbdd78c = "www.atlassian.com.v2_dev";
const $bfeeaa29e3f9a245$export$9af986fa17e71039 = "www.atlassian.com.v3";
const $bfeeaa29e3f9a245$export$a7eaf02eb519d647 = "www.atlassian.com.v3_dev";
const $bfeeaa29e3f9a245$export$e9dac33bbaf86e02 = $bfeeaa29e3f9a245$export$74b39503c55b7612;
const $bfeeaa29e3f9a245$export$b337d69b7a65e111 = $bfeeaa29e3f9a245$export$9af986fa17e71039;
const $bfeeaa29e3f9a245$export$5049c8654c52de2a = "aa-autocomplete-pce";
async function $bfeeaa29e3f9a245$export$b887d873139badc3({ objectID: objectID, queryID: queryID }) {
    const algoliaApplicationID = $bfeeaa29e3f9a245$export$17b978e8ab9e4c58;
    const algoliaAdminAPIKey = $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1;
    const insightsURL = `https://insights.algolia.io/1/events`;
    const anonymousId = (0, $gFK1O.Cookie).readCookie("ajs_anonymous_id");
    let decodedAnonymousId;
    if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
    decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, "");
    const eventData = {
        events: [
            {
                eventType: "conversion",
                eventName: "Result clicked (global nav)",
                index: $bfeeaa29e3f9a245$export$e9dac33bbaf86e02,
                userToken: decodedAnonymousId,
                objectIDs: [
                    objectID
                ],
                queryID: queryID
            }
        ]
    };
    try {
        const response = await (0, $2bsWQ.fetch)(insightsURL, {
            method: "POST",
            headers: {
                "X-Algolia-Application-Id": algoliaApplicationID,
                "X-Algolia-API-Key": algoliaAdminAPIKey,
                "Content-Type": "text/plain;charset=UTF-8"
            },
            body: JSON.stringify(eventData)
        });
        if (!response.ok) throw new Error(`Error: ${response.statusText}`);
    } catch (error) {
        console.error("Failed to send event:", error);
    }
}
const $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist = ()=>{
    if (localStorage.getItem($bfeeaa29e3f9a245$export$5049c8654c52de2a)) (0, $1syhO.removeLocalStorage)($bfeeaa29e3f9a245$export$5049c8654c52de2a);
};
const $bfeeaa29e3f9a245$var$setPotentialConversionEventLocalStorage = (stringifyConversionEventObject)=>{
    // reset localstorage if already exist
    $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist();
    (0, $1syhO.setLocalStorage)($bfeeaa29e3f9a245$export$5049c8654c52de2a, stringifyConversionEventObject, 3600 // per code comment, ttl in seconds for the localstorage. 3600 secs = 1hr
    );
};
const $bfeeaa29e3f9a245$export$120e7b764d5fde54 = (item)=>{
    if (item.url.includes("/signup")) {
        $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist();
        $bfeeaa29e3f9a245$export$b887d873139badc3({
            objectID: item.objectID,
            queryID: item.queryID,
            position: item.position
        });
    } else if (item.url.includes("/software/")) {
        const stringifyAttributes = JSON.stringify({
            objectID: item.objectID,
            queryID: item.queryID,
            position: item.position
        });
        $bfeeaa29e3f9a245$var$setPotentialConversionEventLocalStorage(stringifyAttributes);
    }
};
function $bfeeaa29e3f9a245$export$3d596a295dd7fc61(props) {
    const { resultsCount: resultsCount, searchTerm: searchTerm } = props;
    const [dropdownAnnouncement, setDropdownAnnouncement] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        setDropdownAnnouncement("");
    }, [
        searchTerm
    ]);
    const intl = (0, $f6qj2.default)();
    (0, $iSvIT.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDropdownAnnouncement(intl.formatMessage({
                id: "AutoCompleteSearchBar.dropdown.announcement",
                defaultMessage: '{resultsCount} results displayed for search-term "{searchTerm}"'
            }, {
                resultsCount: resultsCount,
                searchTerm: searchTerm
            }));
        }, 2000);
        return ()=>clearTimeout(timer);
    }, [
        resultsCount,
        searchTerm
    ]);
    return {
        dropdownAnnouncement: dropdownAnnouncement
    };
}
const $bfeeaa29e3f9a245$export$e96bd116e2b4049a = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-live": "polite",
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsbt94y _4t3it94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogtohxbz _1reo15vq _18m915vq"
        ]),
        children: props.children
    });
};

});

parcelRegister("3Bf61", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29f0898d81776aa2$var$_react = $29f0898d81776aa2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $29f0898d81776aa2$var$_chevronRight = $29f0898d81776aa2$var$_interopRequireDefault((parcelRequire("fOYRZ")));
function $29f0898d81776aa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $29f0898d81776aa2$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $29f0898d81776aa2$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $29f0898d81776aa2$var$_chevronRight.default,
        iconType: "utility"
    }));
$29f0898d81776aa2$var$ChevronRightLargeIcon.displayName = "ChevronRightLargeIcon";
var $29f0898d81776aa2$var$_default = module.exports.default = $29f0898d81776aa2$var$ChevronRightLargeIcon;

});
parcelRegister("fOYRZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281ba53efaa7c88b789646091262f5f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b84abdffa30de06b$var$_react = $b84abdffa30de06b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b84abdffa30de06b$var$_baseNew = $b84abdffa30de06b$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b84abdffa30de06b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b84abdffa30de06b$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $b84abdffa30de06b$var$_react.default.createElement($b84abdffa30de06b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.94 6 3.97 2.03 5.03.97l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$b84abdffa30de06b$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $b84abdffa30de06b$var$_default = module.exports.default = $b84abdffa30de06b$var$ChevronRightIcon;

});


parcelRegister("d0cJX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9775286909ac5557$var$_react = $9775286909ac5557$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $9775286909ac5557$var$_chevronLeft = $9775286909ac5557$var$_interopRequireDefault((parcelRequire("8ZHrU")));
function $9775286909ac5557$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9775286909ac5557$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $9775286909ac5557$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $9775286909ac5557$var$_chevronLeft.default,
        iconType: "utility"
    }));
$9775286909ac5557$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $9775286909ac5557$var$_default = module.exports.default = $9775286909ac5557$var$ChevronLeftLargeIcon;

});
parcelRegister("8ZHrU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68c5b95a09f26cb8$var$_react = $68c5b95a09f26cb8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $68c5b95a09f26cb8$var$_baseNew = $68c5b95a09f26cb8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $68c5b95a09f26cb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68c5b95a09f26cb8$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $68c5b95a09f26cb8$var$_react.default.createElement($68c5b95a09f26cb8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$68c5b95a09f26cb8$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $68c5b95a09f26cb8$var$_default = module.exports.default = $68c5b95a09f26cb8$var$ChevronLeftIcon;

});


parcelRegister("Erp3T", function(module, exports) {
$parcel$export(module.exports, "useProductIntent", function () { return (parcelRequire("kjssF")).useProductIntent; });
parcelRequire("eeJVi");
parcelRequire("kjssF");

});
parcelRegister("eeJVi", function(module, exports) {

$parcel$export(module.exports, "ProductKey", function () { return $638022cbdd0e1e88$export$f3a53bd43617a593; });
$parcel$export(module.exports, "products", function () { return $638022cbdd0e1e88$export$b6aad051bad07f12; });
var $638022cbdd0e1e88$export$f3a53bd43617a593;
(function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
})($638022cbdd0e1e88$export$f3a53bd43617a593 || ($638022cbdd0e1e88$export$f3a53bd43617a593 = {}));
const $638022cbdd0e1e88$export$b6aad051bad07f12 = [
    {
        bundle: "jira-software",
        description: "Jira",
        key: "jira-software.ondemand",
        name: "jira"
    },
    {
        bundle: "confluence",
        description: "Confluence",
        key: "confluence.ondemand",
        name: "confluence"
    },
    {
        bundle: "jira-service-management",
        description: "Jira Service Management",
        key: "jira-servicedesk.ondemand",
        name: "jira-servicedesk"
    },
    {
        bundle: "jira-product-discovery",
        description: "Jira Product Discovery",
        key: "jira-product-discovery",
        name: "jira-product-discovery"
    }
];

});

parcelRegister("kjssF", function(module, exports) {

$parcel$export(module.exports, "useProductIntent", function () { return $ead1ccf5e671c3c5$export$93cccec4b411f62; });

var $iSvIT = parcelRequire("iSvIT");

var $eeJVi = parcelRequire("eeJVi");
const $ead1ccf5e671c3c5$export$93cccec4b411f62 = ()=>// eslint-disable-next-line complexity
    (0, $iSvIT.useMemo)(()=>{
        let edition;
        let product;
        if (typeof window === "undefined") return {
            edition: edition,
            product: product
        };
        const params = new URLSearchParams(window.location.search);
        if (window.location.pathname.includes("/software/jira/product-discovery")) {
            product = {
                bundle: "jira-product-discovery",
                description: "Jira Product Discovery",
                key: (0, $eeJVi.ProductKey).JIRA_PRODUCT_DISCOVERY,
                name: "jira-product-discovery"
            };
            edition = "free";
        } else if (window.location.pathname.includes("/software/jira/service-management")) {
            product = {
                bundle: "jira-service-management",
                description: "Jira Service Management",
                key: (0, $eeJVi.ProductKey).JIRA_SERVICE_MANAGEMENT,
                name: "jira-servicedesk"
            };
            edition = "free";
        } else if (window.location.pathname.includes("/software/jira")) {
            product = {
                bundle: "jira-software",
                description: "Jira",
                key: (0, $eeJVi.ProductKey).JIRA_SOFTWARE,
                name: "jira"
            };
            edition = "free";
        }
        if (window.location.pathname.includes("/software/confluence")) {
            product = {
                bundle: "confluence",
                description: "Confluence",
                key: (0, $eeJVi.ProductKey).CONFLUENCE,
                name: "confluence"
            };
            edition = "free";
        }
        const isSignupPage = window.location.pathname.endsWith("/try/cloud/signup");
        const isConfirmationPage = window.location.pathname.endsWith("/ondemand/signup/confirmation");
        if (isSignupPage || isConfirmationPage || window.IS_STORYBOOK) {
            // defaults for the signup page
            if (isSignupPage) {
                edition = "free";
                product = {
                    bundle: "jira-software",
                    description: "Jira",
                    key: (0, $eeJVi.ProductKey).JIRA_SOFTWARE,
                    name: "jira"
                };
            }
            // determine product
            if (params.has("product")) product = (0, $eeJVi.products).find((product)=>product.key === params.get("product"));
            else if (params.has("bundle")) product = (0, $eeJVi.products).find((product)=>product.bundle === params.get("bundle"));
            else if (params.has("products")) product = (0, $eeJVi.products).find((product)=>product.key === params.get("products")?.split(",")[0]);
            // determine edition
            const editionParam = params.get("edition");
            if (editionParam === "free") edition = "free";
            else if (editionParam === "standard") edition = "standard";
            else if (editionParam === "premium") edition = "premium";
        }
        return {
            edition: edition,
            product: product
        };
    }, []);

});


parcelRegister("96J8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a17ae9c03e0d534$var$_react = $6a17ae9c03e0d534$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $6a17ae9c03e0d534$var$_appSwitcher = $6a17ae9c03e0d534$var$_interopRequireDefault((parcelRequire("3adMY")));
function $6a17ae9c03e0d534$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6a17ae9c03e0d534$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $6a17ae9c03e0d534$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
    }, props, {
        newIcon: $6a17ae9c03e0d534$var$_appSwitcher.default
    }));
$6a17ae9c03e0d534$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $6a17ae9c03e0d534$var$_default = module.exports.default = $6a17ae9c03e0d534$var$AppSwitcherIcon;

});
parcelRegister("3adMY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a710c2ad5ea3773aa39998727af6369>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24dd0071693629a9$var$_react = $24dd0071693629a9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $24dd0071693629a9$var$_baseNew = $24dd0071693629a9$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $24dd0071693629a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $24dd0071693629a9$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $24dd0071693629a9$var$_react.default.createElement($24dd0071693629a9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$24dd0071693629a9$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $24dd0071693629a9$var$_default = module.exports.default = $24dd0071693629a9$var$AppSwitcherIcon;

});


parcelRegister("f448m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af7a6fa2fff8eb61$var$_react = $af7a6fa2fff8eb61$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $af7a6fa2fff8eb61$var$_close = $af7a6fa2fff8eb61$var$_interopRequireDefault((parcelRequire("i3sQU")));
function $af7a6fa2fff8eb61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $af7a6fa2fff8eb61$var$CrossIcon = (props)=>/*#__PURE__*/ $af7a6fa2fff8eb61$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $af7a6fa2fff8eb61$var$_close.default
    }));
$af7a6fa2fff8eb61$var$CrossIcon.displayName = "CrossIcon";
var $af7a6fa2fff8eb61$var$_default = module.exports.default = $af7a6fa2fff8eb61$var$CrossIcon;

});
parcelRegister("i3sQU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d24ee34c820fd1da$var$_react = $d24ee34c820fd1da$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d24ee34c820fd1da$var$_baseNew = $d24ee34c820fd1da$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d24ee34c820fd1da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d24ee34c820fd1da$var$CloseIcon = (props)=>/*#__PURE__*/ $d24ee34c820fd1da$var$_react.default.createElement($d24ee34c820fd1da$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$d24ee34c820fd1da$var$CloseIcon.displayName = "CloseIcon";
var $d24ee34c820fd1da$var$_default = module.exports.default = $d24ee34c820fd1da$var$CloseIcon;

});


parcelRegister("iewWE", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $d46316fee07c4bd0$export$74665b213cb5c4cf; });

var $4mm8O = parcelRequire("4mm8O");

var $iwCDs = parcelRequire("iwCDs");
function $d46316fee07c4bd0$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $iwCDs.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $4mm8O.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("4mm8O", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $32ca6449da447beb$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $32ca6449da447beb$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("iwCDs", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $d7c92f513cf313e3$export$25bec8c6f54ee79a; });

var $iSvIT = parcelRequire("iSvIT");
function $d7c92f513cf313e3$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $iSvIT.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("kA3CX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03ddd6a42924c0fc$export$2e2bcd8739ae039; });
var $03ddd6a42924c0fc$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $03ddd6a42924c0fc$export$2e2bcd8739ae039 = $03ddd6a42924c0fc$var$rafSchd;

});

parcelRegister("kzsvd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef9d2f8982363c32$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");
var $ef9d2f8982363c32$var$formFooterWrapperStyles = (0, $2ZUkg.css)({
    display: "flex",
    marginTop: "var(--ds-space-300, 24px)",
    justifyContent: "flex-end"
});
var $ef9d2f8982363c32$var$justifyContentStyles = (0, $2ZUkg.css)({
    justifyContent: "flex-start"
});
function $ef9d2f8982363c32$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? "end" : _ref$align, children = _ref.children;
    return (0, $2ZUkg.jsx)("footer", {
        css: [
            $ef9d2f8982363c32$var$formFooterWrapperStyles,
            align === "start" && $ef9d2f8982363c32$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("A9zZc", function(module, exports) {

$parcel$export(module.exports, "SanitizedRichText", function () { return $d50557d96565ccec$export$efb77abbd0a81997; });
/* sanitized-rich-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $7L1zQ = parcelRequire("7L1zQ");
const $d50557d96565ccec$var$styles = null;
const $d50557d96565ccec$export$efb77abbd0a81997 = ({ innerHTML: innerHTML, tagName: Component = "span", className: className })=>{
    if (typeof innerHTML === "string") return /*#__PURE__*/ (0, $loA2J.jsx)(Component, {
        className: (0, $esG4f.default)([
            "_754n1j6v _1ci51k8s _zgxm1nn1 _171salr3 _1xsslnmy _1vapidpf _1qwqidpf _14qeidpf _18obidpf _1ps4rbzz _qs4s1r31 _iidjglyw _jopknqa1 _1dipoelr _1bw11r31 _swvz8stv _1vxgnqa1 _1uo11r31 _gugqglyw _1l07nqa1 _mvak1r31 _17u5glyw _1ldznqa1 _116xrbzz _15zsidpf _150widpf _1g0midpf _1s9iidpf _xbdr1tcg",
            `styled-text ${className ?? ""}`
        ]),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))(innerHTML)
        }
    });
    else return null;
};

});

parcelRegister("isSvf", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("lxS8L")).Video; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("lxS8L")).Video; });

var $lxS8L = parcelRequire("lxS8L");

});
parcelRegister("lxS8L", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $ed253e67f972fd3a$export$ae01dedf5c052bb; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ed253e67f972fd3a$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return {
        maxWidth: "100%",
        ...aspectRatioCSS
    };
};
const $ed253e67f972fd3a$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $iSvIT.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $ed253e67f972fd3a$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});



var $7Tq4R = parcelRequire("7Tq4R");

var $dRBBv = parcelRequire("dRBBv");
(0, $7Tq4R.init)((0, $dRBBv.JiraServiceManagementSoftwarePage));


//# sourceMappingURL=jira-service-management-software-page.e273c74d.js.map
